import Box from '../../Atoms/Box';
import CCText from '../../Atoms/CCText';
import CCButton from '../../Atoms/CCButton';
import React, {useCallback, useEffect, useState, useRef, useMemo} from 'react';
import {
  View,
  TextInput,
  BackHandler,
  Alert,
  Switch,
  ActivityIndicator,
} from 'react-native';
import usePuzzleFeedback from '@/Hooks/FeedbackApi/useFeedback';
import Spacer from '@/Atoms/Spacer';
import {
  vs,
  isPhone,
  FontSizes,
  hs,
  isPortrait,
  SCREEN_WIDTH,
} from '../../Utils/Dimensions';
import useAlertModalStore from '@/Store/AlertModalStore';
import {useToast} from '@/toast/useToast';
import {styles, filterStyles, infoStyles, rightPaneStyles} from './styles';
import ChessboardComponent from 'chessboard-package';
import {joinGameHandler} from './gamePlaHandlers';
import {Chess} from 'chess.js';
import {MOBILE_HEADER_HEIGHT} from '@/Utils/Constants';
import BottomSheetPlay from '@/Atoms/BottomSheetPlay';
// import DrawRequestModal from './DrawRequestModal';
import {Modal, Text, Button, ScrollView, TouchableOpacity} from 'react-native';
import useGetProfileApi from '@/Hooks/ProfileApi/profileApi';
import Environment from '../../../environment';

import TimeControl from './components/TimeControl';
import GameSearchComponent from './components/GameSearch';

import useSaveCircleChessGame from '@/Hooks/SaveCircleChessGame/useSaveCircleChessGame';
import useCheckCircleChessGamesAnalyzedRule from '@/Hooks/SaveCircleChessGame/useCheckCircleChessGamesAnalyzedRule';
import useGetGameWithTag from '@/Hooks/GameLibraryApi/useGetGameWithTagApi';
import ClockComponent from './components/ClockComponent';
import PlayerComponent from './components/PlayerComponent';
import NotationComponent from './components/NotationComponent';
import ChallengeComponent from '../../Components/ChallengeComponent';
import ResultComponent from './components/ResultComponent';
import rematch from '@/Assets/Images/icons/Rematch.png';
import {WINDOW_HEIGHT} from '../../Utils/Dimensions';
import MaterialCommunityIcon from 'react-native-vector-icons/MaterialCommunityIcons';
import FontAwesome5 from 'react-native-vector-icons/FontAwesome5';
import CCColors from '@/Utils/CCColors';
import {Pressable} from 'react-native';
import ProgressBar from '@/Atoms/ProgressBar';
import Animated, {
  useSharedValue,
  useAnimatedStyle,
  interpolateColor,
  interpolate,
  withTiming,
} from 'react-native-reanimated';
import useAnimation from '@/Hooks/useAnimation';
import SearchProgressComponent from './components/SearchProgressComponent';
import ChallengeProgressComponent from './components/ChallengeProgressComponent';
import draw_control from '@/Assets/Images/png/draw.png';
import resign_control from '@/Assets/Images/png/resign.png';
import {ScreenName} from '@/navigators/StackConstants';
import {
  useNavigation,
  useRoute,
  useFocusEffect,
} from '@react-navigation/native';
import ComingSoon from '../ComingSoon';
import ShimmerLoader from './components/ShimmerLoader';
import BottomControlsComponent from './components/BottomControlsComponent';
import {
  getLocalStorage,
  removeLocalStorage,
  reverseObject,
  setLocalStorage,
} from '@/Utils/CommonUtils';
import ChallengeRejected from './components/ChallengeRejected';
import GamePlayClient from '@/Api/GameClient';
import GameRules from './components/GameRulesComponent';
import useChessboardColorTheme from '@/Hooks/ChessboardColorTheme/useChessboardColorTheme';
import useAssistedGameMoveAnalysisApi from '@/Hooks/AssistedGameMoveAnalysisApi/useAssistedGameMoveAnalysisApi';
import IdleStateGameBanner from './components/IdleStateGameBanner';
import {
  useNonPersistedUserPlanStore,
  useUserPlanStore,
} from '@/Store/userPlanStore';
import {useMediaQuery} from '@/Hooks/useMediaQuery/useMediaQuery';
import NotificationBox from './components/NotificationBox';
import {useSocket, useSocketReconnect} from '@/Hooks/UseSocket';
import useGamePlayState from '@/Store/GamePlayStore';
import {HintForIncorrectAttempt} from '../Puzzles/next';
import useAssistedPuzzleFeedback from '@/Hooks/FeedbackApi/assistedFeedback';
import ConnectionModal from './components/ConnectionModal';
import WinningBar from '../ChessAnalysis/component/WinningBar';
import StockfishEngine from '@/Components/StockfishEngine';
import TournamentPlay from '../CCTournaments/components/TournamentPlay';
// Arena tournaments (tournament_type === 'Circlechess_Arena') — store fed by
// the arena_* socket handlers below; berserk control rendered on the mobile
// live board (desktop arena board renders it inside TournamentPlay).
import useArenaStore from '@/Store/ArenaStore';
import ArenaBerserkControl from '../CCTournaments/components/Arena/ArenaBerserkControl';
import useCreateLeagueMatchApi from '@/Hooks/LeaguesApi/createLeagueMatchApi';
// Phase B — chessground-backed wrapper on web (via index.web.tsx); falls back
// to the legacy ChessboardWithArrow on native via index.native.tsx. Prop surface
// + imperative ref API are identical, so JSX usage below stays unchanged.
import ChessboardWithArrow from '@/Components/Chessboard';
import useGetUserGamesApi from '@/Hooks/GetUserGamesApi/useGetUserGamesApi';
import {fetchArenaGameReplay} from '@/Screens/CCTournaments/components/hooks/useGetArenaPlayerGames';
import home from '@/Assets/Images/png/home.png';
import newGame from '@/Assets/Images/png/newGame.png';
import {CustomInfoBox} from '@/Atoms/InfoIcon';
import prize from '@/Assets/Images/Svgs/prize.svg';
import gameStartSound from '../../Assets/Sounds/game_start.mp3';
import roundStartSound from '../../Assets/Sounds/round_start.mp3';
import drawsound from '@/Assets/Sounds/draw_offer.mp3';
import confirmation from '@/Assets/Sounds/Confirmation.mp3';
import useSound from 'use-sound';
// const schema = require('/Users/whynew/Circlechess/cc-client-sdk/lib/schema.js');

const {v4: uuidv4} = require('uuid');

// const cc_ws_client = require('/var/www/game-service/cc-client-sdk/lib/index.js');
// const schema = require('/var/www/game-service/cc-client-sdk/lib/schema.js');
const {schema, cc_ws_client} = require('../../../CCClientSdk');
// const cc_ws_client = require('/home/abhijeet/cc-client-sdk/lib/index');
// const schema = require('/Users/nitu/Circlechess/cc-client-sdk/lib/schema.js');
function classifyTimeControl(duration, increment) {
  // Calculate the total time in minutes
  const totalTime = (duration + increment) / 60000;

  // Classify based on total time
  if (totalTime < 3) {
    return 'Bullet';
  } else if (totalTime < 10) {
    return 'Blitz';
  } else if (totalTime < 30) {
    return 'Rapid';
  } else {
    return 'Classical';
  }
}

function calculateWinRatios(stockfishScore) {
  let whiteWinRatio, blackWinRatio;

  // Check if the score is a mate score (e.g., "#3" or "#-5")
  if (typeof stockfishScore === 'string' && stockfishScore.startsWith('#')) {
    const mateMoves = parseInt(stockfishScore.substring(1), 10);
    if (mateMoves > 0) {
      // White is forcing a mate
      whiteWinRatio = 1.0; // 100% win for White
      blackWinRatio = 0.0;
    } else {
      // Black is forcing a mate
      whiteWinRatio = 0.0;
      blackWinRatio = 1.0; // 100% win for Black
    }
  } else {
    // Centipawn score case
    const evaluation = stockfishScore / 100.0; // Convert centipawns to pawns

    // Apply logistic function to convert evaluation into a win ratio
    const winProbability = 1 / (1 + Math.exp(-0.4 * evaluation)); // Tuned scaling factor (0.4)
    whiteWinRatio = parseFloat(winProbability.toFixed(2));
    blackWinRatio = parseFloat((1 - winProbability).toFixed(2));
  }

  return {whiteWinRatio, blackWinRatio};
}

function useIsFirstRender() {
  const isFirst = useRef(true);

  useEffect(() => {
    isFirst.current = false;
  }, []);

  return isFirst.current;
}

// Merge an incoming authoritative move list into the locally-rendered one
// WITHOUT ever dropping moves we already show. Each player_turn_response carries
// the move list up to that event, but events can land out of order: a premove's
// own response races a delayed setMoves from the opponent's move (the opponent
// branch defers setMoves by 50ms). A naive "replace unless it's a forward
// extension" then lets that stale, shorter update clobber the newer premove.
// Rules:
//   - prevMoves is a prefix of newMoves -> incoming extends history -> append tail
//   - newMoves is a prefix of prevMoves -> incoming is stale/shorter but
//     consistent -> keep ours (this is the premove-notation fix)
//   - otherwise genuine divergence (new game / different line) -> adopt incoming
function mergeMoveList(prevMoves, newMoves) {
  if (prevMoves.length === 0) return newMoves;

  const prevExtendsToNew = prevMoves.every(
    (pm, i) => newMoves[i] && newMoves[i].move === pm.move,
  );
  if (prevExtendsToNew) {
    return newMoves.length > prevMoves.length
      ? [...prevMoves, ...newMoves.slice(prevMoves.length)]
      : prevMoves; // equal length -> nothing new
  }

  const newIsStalePrefix = newMoves.every(
    (nm, i) => prevMoves[i] && prevMoves[i].move === nm.move,
  );
  if (newIsStalePrefix) return prevMoves;

  return newMoves;
}

// Derive captured pieces from a board FEN (server no longer sends them — perf
// Phase 2). Pure: depends only on the FEN string, so it lives at module scope
// (not recreated per render) and can be memoised by callers. Guards
// empty/invalid input -> {w: [], b: []}.
function getCapturedPieces(fen) {
  if (!fen || typeof fen !== 'string') return {w: [], b: []};
  const initialPieceCount = {
    w: {p: 8, n: 2, b: 2, r: 2, q: 1, k: 1},
    b: {p: 8, n: 2, b: 2, r: 2, q: 1, k: 1},
  };
  const currentPieceCount = {w: {}, b: {}};
  const [board] = fen.split(' ');
  board.split('/').forEach(row => {
    for (const char of row) {
      if (Number.isInteger(parseInt(char))) continue; // empty squares
      const color = char === char.toUpperCase() ? 'w' : 'b';
      const type = char.toLowerCase();
      currentPieceCount[color][type] =
        (currentPieceCount[color][type] || 0) + 1;
    }
  });
  const capturedPieces = {w: [], b: []};
  ['w', 'b'].forEach(color => {
    Object.keys(initialPieceCount[color]).forEach(type => {
      const diff =
        initialPieceCount[color][type] - (currentPieceCount[color][type] || 0);
      for (let i = 0; i < diff; i++) {
        capturedPieces[color].push(color === 'w' ? type.toUpperCase() : type);
      }
    });
  });
  return capturedPieces;
}

function PlayChess({
  isBeginnerPlayer,
  changeClient,
  setChangeClient,
  authComplete,
}) {
  const isFirstRender = useIsFirstRender();
  const [playing, setPlaying] = useState(false);
  const [client, setClient] = useState(null);
  const [isConnected, setIsConnected] = useState(true);
  const [success, setSuccess] = useState(false);
  const [errorMsg, setErrorMsg] = useState(null);
  const [username, setUsername] = useState('');
  const [game_uuid, setGameUuid] = useState('');
  const navigation = useNavigation();
  const [isStaff, setIsStaff] = useState(true);
  const [isStaffNew, setIsStaffNew] = useState(false);
  const [accessToken, setAccessToken] = useState('');
  const [showChange, setShowChange] = useState(false);
  const [goodFeedback, setGoodFeedback] = useState(0);
  const [badFeedback, setBadFeedback] = useState(0);
  const [displayName, setDisplayName] = useState('');
  const [opponentDisplayName, setOpponentDisplayName] = useState('');
  const chessboardColorTheme = useChessboardColorTheme();
  const route = useRoute();
  const {setSubscriptionModalOpen} = useNonPersistedUserPlanStore();
  const userPlanDetails = useUserPlanStore();
  const [activePlan, setActivePlan] = useState(
    userPlanDetails.activePlan || 'novice',
  );
  const [assistedGameplay, setAssistedGameplay] = useState(false);
  const [gameDetails, setGameDetails] = useState('');
  const [gamePlayMode, setGamePlayMode] = useState('Play');
  const [hintMessage, setHintMessage] = useState('');
  const [whiteWinRatio, setWhiteWinRatio] = useState(0.5);
  const [blackWinRatio, setBlackWinRatio] = useState(0.5);
  const [fen, setFen] = useState(
    'rnbqkbnr/pppppppp/8/8/8/8/PPPPPPPP/RNBQKBNR w KQkq - 0 1',
  );
  const openAlertModal = useAlertModalStore(state => state.openModal);

  const fenRef = useRef(
    'rnbqkbnr/pppppppp/8/8/8/8/PPPPPPPP/RNBQKBNR w KQkq - 0 1',
  );
  // retry move on packet drop states
  const [lastMove, setLastMove] = useState('');
  const [lastMoveSent, setLastMoveSent] = useState(false);
  const lastMovetimeoutRef = useRef(null);
  const [userId, setUserId] = useState('');
  const [uuid, setUuid] = useState(0);
  const [enableLearn, setEnableLearn] = useState(false);
  const [withdraw, setWithdraw] = useState(false);

  const gameplayStore = useGamePlayState();

  // ── Arena mode ────────────────────────────────────────────────────────────
  // isArena is derived by TournamentPlay from tournament details
  // (tournament_type === 'Circlechess_Arena') and pushed into ArenaStore; the
  // ref mirrors it for the socket-handler closures registered inside
  // CCApplicationClient (which would otherwise capture a stale value).
  const isArena = useArenaStore(state => state.isArena);
  const arenaIsJoined = useArenaStore(state => state.isJoined);
  const arenaStatus = useArenaStore(state => state.status);
  const arenaMyBerserk = useArenaStore(state => state.myBerserk);
  const isArenaRef = useRef(isArena);
  useEffect(() => {
    isArenaRef.current = isArena;
  }, [isArena]);
  // The berserk handler must know which table I'm CURRENTLY seated at, but
  // the CCApplicationClient closure `tableid` resets to undefined whenever
  // that effect re-runs (username/accessToken/socket change) mid-game —
  // silently dropping the opponent's berserk badge/clock. Mirror the id into
  // a ref (same pattern as tournamentIdRef) assigned in
  // startGameResponseCallback.
  const arenaTableIdRef = useRef(null);
  // Auto-resume gate: pool a joined-but-idle player at most ONCE per
  // tournament visit (reset when the tournament changes — see the reset
  // effect next to the tournamentId declaration below), so the effect can't
  // loop and a deliberate pause is never overridden.
  const arenaAutoResumedRef = useRef(false);
  // Toast for user-visible arena notices (berserk refusals). The provider
  // memoizes showToast, so the CCApplicationClient closures can capture it.
  const showToast = useToast();

  const chessboardRef = useRef(null);

  const socket = useSocket();
  const reconnectSocket = useSocketReconnect();
  const [tournamentName, setTournamentName] = useState('');
  useEffect(() => {
    if (isFirstRender) {
      gameplayStore?.setShowChangeInClient(false);
    }
  }, [isFirstRender]);

  // Clears all CSOC league-challenge keys. Previously only league_opp_id was
  // cleared (and only on a successful match), so league_id / league_opp_name —
  // or all of them after an aborted/abandoned challenge — leaked and
  // mis-attributed the next ordinary game as a league match.
  const clearLeagueChallengeKeys = async () => {
    await removeLocalStorage('league_opp_id');
    await removeLocalStorage('league_id');
    await removeLocalStorage('league_opp_name');
  };
  const handleCreateMatchSuccess = async () => {
    await clearLeagueChallengeKeys();
  };
  const {mutate: createLeagueMatch} = useCreateLeagueMatchApi(
    handleCreateMatchSuccess,
  );
  // Clear pending league-challenge keys when leaving PlayChess, so a
  // half-finished / abandoned league challenge cannot leak into a later game.
  useEffect(() => {
    return () => {
      clearLeagueChallengeKeys();
    };
  }, []);
  // Release the tournament-play gate on unmount. The flag is set true when
  // the user enters a tournament and read by ChallengeComponent to suppress
  // incoming challenges; without this cleanup the flag stayed true after the
  // user navigated away (router push, browser back, deep-link) and challenges
  // remained invisible on every other screen for the rest of the session.
  useEffect(() => {
    return () => {
      gameplayStore.setTournamentPlay(false);
    };
  }, []);
  // Tell the server to remove this socket from `tournament_<id>` when we
  // either leave the page OR switch to a different tournament without
  // PlayChess unmounting (deep-link / param change). The server-side handler
  // keeps participants in the room — only spectators are evicted — so this
  // is safe to fire from any exit, including a participant's page navigation.
  const tournamentIdRef = useRef(tournamentId);
  const clientRef = useRef(client);
  useEffect(() => {
    tournamentIdRef.current = tournamentId;
  }, [tournamentId]);
  useEffect(() => {
    clientRef.current = client;
  }, [client]);
  const sendStopWatchingTournament = (tid, c) => {
    if (!tid || !c) return;
    const packet = {
      requestId: new Date().getTime().toString(),
      type: 'stop_watching_tournament_request',
      tournamentId: tid.toString(),
    };
    c.send_msg('stop_watching_tournament_request', packet);
  };
  // Leave the PREVIOUS tournament's room when tournamentId changes. The
  // actual effect lives in the tournamentIdRef re-sync effect BELOW the
  // tournamentId useState — an effect declared here evaluates its dep
  // against the const→var-hoisted (still-undefined) binding on every render
  // and never re-fires after mount.
  const prevTournamentIdRef = useRef(0);
  // Leave the CURRENT tournament's room on full unmount.
  useEffect(() => {
    return () => {
      sendStopWatchingTournament(tournamentIdRef.current, clientRef.current);
      // Arena mode is screen-scoped — clear it so a later non-arena visit
      // doesn't inherit stale status/standings/berserk flags.
      useArenaStore.getState().resetArena();
    };
  }, []);

  const handleClearPremoves = () => {
    // console.log('clearing premoves 1');
    if (chessboardRef?.current) {
      // console.log('clearing premoves 2');
      chessboardRef?.current?.clearPremoves?.();
    }
  };

  const attemptPremove = color => {
    if (chessboardRef?.current) {
      chessboardRef?.current?.attemptPremove(color);
    }
  };

  useEffect(() => {
    const {tournamentId, tournamentName} = route.params || {};

    if (tournamentId) {
      setTournamentId(tournamentId);
      getTournamentDetails(tournamentId);
      if (tournamentName) {
        setTournamentName(tournamentName);
      }
    }
  }, [route.params]);
  useEffect(() => {
    const {from} = route.params || {};
    if (from) {
      setGamePlayMode('tournament');
    }
  }, [route.params]);

  const handleProfileGetSuccess = responseData => {
    // console.log('Profile Data = ', responseData);
    setSuccess(false);
    setErrorMsg(null);
    const user_id = responseData.data.user[0].pk;
    const avatarData = responseData.data.avatar[0].fields;
    const display_name = responseData.data.user[0].fields.username;
    setUsername(user_id.toString()); // logging in to the socket using user_id instead of username, will resolve later
    setDisplayName(display_name);
    setmyRating(responseData.data.user[0].fields.gameplay_rating);
    setUsernameTournament(user_id.toString());
    setDisplayNameTournament(display_name);
    setMyRatingTournament(responseData.data.user[0].fields.gameplay_rating);
    console.log(
      'customRules : ',
      responseData.data.user[0].fields.custom_rules,
    );
    setCustomRules(responseData.data.user[0].fields.custom_rules);
    if (
      responseData.data.user[0].fields.custom_rules.includes(
        'games_reviewed_rule',
      )
    ) {
      CheckCircleChessGamesAnalyzedRule({userId: user_id});
    }
    setUserId(user_id);
    const is_staff = responseData.data.user[0].fields.is_staff;
    // console.log('is_staff is : ', is_staff);
    setIsStaffNew(is_staff);
    // setIsStaff(false);
    setEnableLearn(is_staff);
  };

  const handleOnError = responseData => {};

  const {
    mutate: getProfile,
    data: validatedData,
    error: validatedError,
    isLoading,
  } = useGetProfileApi(handleProfileGetSuccess, handleOnError);

  const setAuthorizationToken = async () => {
    const token = await getLocalStorage('access_token');
    if (token) {
      setAccessToken(`Bearer ${token}`);
    }
  };

  useEffect(() => {
    console.log('Getting profile data .. ');
    gameplayStore.setJoinedTournament(false);
    gameplayStore.setJoinedTournamentId('0');
    setSuccess(false);
    getProfile();
    console.log('Getting access token .. ');
    setAuthorizationToken();

    const getLastGameTimeControl = async () => {
      const timeControlData = await getLocalStorage('lastGameTimeControl');
      console.log(
        'Last game move timer is : ',
        JSON.stringify(timeControlData),
      );
      if (timeControlData) {
        setMoveTimer(timeControlData.moveTimer);
        setIncrement(timeControlData.Increment);
        let timecontrol =
          (timeControlData.moveTimer / 1000).toString() +
          ' + ' +
          (timeControlData.Increment / 1000).toString();
        setTimeControl(timecontrol);
      }
    };
    const getopponent = async () => {
      const opponentData = await getLocalStorage('opponent');
      console.log('opponent is : ', JSON.stringify(opponentData));
      if (opponentData) {
        setOpponentDisplayName(opponentData.displayName);
        setopponentRating(opponentData.rating);
        setStartfen(opponentData.startfen);
        if (opponentData.startfen.split(' ')[1] == 'b') {
          setIsBlackTurnFirst(true);
        }
        if (opponentData.assistedGameplay) {
          setGamePlayMode('Play and Learn');
        }
        setAssistedGameplay(opponentData.assistedGameplay);
        setGameDetails(opponentData.gameDetails);
      }
    };

    const getMoves = async () => {
      const movesData = await getLocalStorage('moves');
      console.log('moves are : ', JSON.stringify(movesData));
      if (movesData) {
        setMoves(movesData);
      }
    };

    getLastGameTimeControl();
    // getopponent();
    getMoves();

    // return (() => {
    //   debugger
    // })
  }, []);

  const getMoves = async moves => {
    try {
      const prevmoves = await getLocalStorage('moves');

      setTimeout(() => {
        if (prevmoves.length > 0) {
          setMoves(() => {
            const newMoves = moves.map(move => ({
              move: move,
              matched: false,
              isHumanMove: false,
            }));
            // If there are no existing moves, just set the new moves
            // Check if the beginning of newMoves matches prevmoves
            const isPrefix = prevmoves.every(
              (prevMove, index) =>
                newMoves[index] && newMoves[index].move === prevMove.move,
            );

            if (isPrefix) {
              // Append only the new moves that are not in prevmoves
              return [...prevmoves, ...newMoves.slice(prevmoves.length)];
            } else {
              return newMoves;
            }
            // return newMoves;
          });
        }
      }, 1000);
      // return prevmoves; // Return the movesData
    } catch (error) {
      console.error('Error retrieving moves:', error);
      return null; // Return null or handle the error as needed
    }
  };

  useEffect(() => {
    console.log('settinng local storage last game move timer');
    const updateLocalStorage = async () => {
      try {
        await setLocalStorage(
          'lastGameTimeControl',
          {moveTimer: MoveTimer, Increment: Increment},
          false,
          () => {},
        );
      } catch (error) {
        console.error('Failed to set local storage:', error);
      }
    };

    if (MoveTimer) {
      updateLocalStorage();
    }
  }, [game_uuid]);

  useEffect(() => {
    console.log('settinng local storage opponent');
    const updateLocalStorage = async () => {
      try {
        await setLocalStorage(
          'opponent',
          {
            displayName: opponentDisplayName,
            rating: opponentRating,
            startfen: startfen,
            assistedGameplay: assistedGameplay,
            gameDetails: gameDetails,
          },
          false,
          () => {},
        );
      } catch (error) {
        console.error('Failed to set local storage opponent:', error);
      }
    };

    if (opponentDisplayName) {
      updateLocalStorage();
    }
  }, [opponentDisplayName, assistedGameplay, gameDetails]);

  const getChessMoveNumber = move_index => {
    const moveNumber = isBlackTurnFirst
      ? Math.ceil((move_index - 1) / 2) + 1
      : Math.floor((move_index - 1) / 2) + 1;
    const color = isBlackTurnFirst
      ? (move_index - 1) % 2 === 0
        ? '...'
        : '.'
      : (move_index - 1) % 2 === 0
      ? '.'
      : '...';
    return `${moveNumber}${color}`;
  };

  const {
    mutate: saveCirclechessGame,
    data: saveCirclechessGameData,
    isLoading: isSaving,
    error: saveError,
  } = useSaveCircleChessGame();

  const handleAssistedGameMoveAnalysisSuccess = data => {
    console.log(
      'API call was successful, received data:',
      JSON.stringify(data),
    );
    if (data && data.hint_response) {
      let mistake = '';
      const move_index = data.move_index - 1;

      const moveNumber = getChessMoveNumber(data.move_index);

      let hintMessage = `${moveNumber} ${data.move} `;
      let hintMessage2 = `${moveNumber} ${data.move} `;

      if (data.blunder) {
        hintMessage += 'is a Blunder! ';
        hintMessage2 += 'is a Blunder! ';
        mistake = 'Blunder';
      } else if (data.mistake) {
        hintMessage += 'is a Mistake! ';
        hintMessage2 += 'is a Mistake! ';
        mistake = 'Mistake';
      } else if (data.inaccuracy) {
        hintMessage += 'is an Inaccuracy! ';
        hintMessage2 += 'is an Inaccuracy! ';
        mistake = 'Inaccuracy';
      }

      if (data.hint_response) {
        hintMessage += data.hint_response;
      }
      if (data.hint_response2) {
        hintMessage2 += data.hint_response2;
      }
      setHintMessage(mistake);
      setHint(hintMessage);
      setHint2(hintMessage2);

      console.log('hint is : ', hintMessage);
      setMoves(prevMoves => {
        // Create a new array to update the specific move
        const updatedMoves = [...prevMoves];
        // Update the move at the specified index
        if (move_index >= 0 && move_index < updatedMoves.length) {
          updatedMoves[move_index] = {
            ...updatedMoves[move_index],
            mistake: mistake,
            hint: hintMessage,
            hint2: hintMessage2,
          };
        }
        return updatedMoves;
      });
      // setTimeout(() => {
      //   setHint('');
      // }, 20000);
    }
    // if(data && data.score){
    //   const { myWinRatio, opponentWinRatio } = calculateWinRatios(data.score);
    //   if(whitePlayer == username){
    //     setWhiteWinRatio(myWinRatio);
    //     setBlackWinRatio(opponentWinRatio);
    //   } else{
    //     setWhiteWinRatio(opponentWinRatio);
    //     setBlackWinRatio(myWinRatio);
    //   }

    //   console.log("WhitewinRatio :", myWinRatio);
    // }
    // Add additional success handling logic here
  };

  const handleAssistedGameMoveAnalysisError = error => {
    console.error('API call failed with error:', error);
    // Add additional error handling logic here
  };

  const {
    mutate: AssistedGameMoveAnalysis,
    data: AssistedGameMoveAnalysisData,
    isLoading: Analysing,
    error: AnalysingError,
  } = useAssistedGameMoveAnalysisApi(
    handleAssistedGameMoveAnalysisSuccess,
    handleAssistedGameMoveAnalysisError,
  );

  const {
    mutate: CheckCircleChessGamesAnalyzedRule,
    data: CheckCircleChessGamesAnalyzedRuleData,
    isLoading: isChecking,
    error: checkrror,
  } = useCheckCircleChessGamesAnalyzedRule();

  const [showReviewGamesComponent, setShowReviewGamesComponent] =
    useState(false);

  // apis to get tags and game fen for selected tag

  const {
    mutate: GetGameWithTag,
    data: GetGameWithTagData,
    isLoading: GettingGameWithTag,
    error: GettingGameWithTagError,
  } = useGetGameWithTag();

  const [tagsSearchResult, setTagsSearchResult] = useState([]);
  const [gameWithTagFen, setGameWithTagFen] = useState('');
  const {isMobileOrTab} = useMediaQuery();
  // setUsername(user.userid);
  const [whitePlayer, setWhitePlayer] = useState(username);
  const [blackPlayer, setBlackPlayer] = useState('Black');
  const [whiteTime, setWhiteTime] = useState(600);
  const [blackTime, setBlackTime] = useState(600);
  const [timeControl, setTimeControl] = useState('');

  const [whitePiecesCaptured, setWhitePiecesCaptured] = useState([]);
  const [blackPiecesCaptured, setBlackPiecesCaptured] = useState([]);

  const [myTurn, setMyTurn] = useState(true);
  const myTurnRef = useRef(myTurn);

  const [isBlackTurnFirst, setIsBlackTurnFirst] = useState(false);

  const [started, setStarted] = useState(false);
  const [Result, setResult] = useState('');

  const [position, setPosition] = useState(
    'rnbqkbnr/pppppppp/8/8/8/8/PPPPPPPP/RNBQKBNR w KQkq - 0 1',
  );
  const [previousFen, setPreviousFen] = useState('');
  const [pgn, setPGN] = useState('');
  const [moves, setMoves] = useState([]);
  // Broadcast-delta: live player/watch turn responses now carry ONLY the new move
  // (the board is FEN-authoritative). This ref holds the full SAN list locally so a
  // delta can be re-expanded into the full moves[] the existing handlers expect.
  // Synced synchronously inside the turn handlers; reset on new game; replaced on
  // reconnect/fetch snapshot. See expandMovesDelta().
  const movesSanRef = useRef([]);
  // Same broadcast-delta tracker for the spectator (watch) move list.
  const watchMovesSanRef = useRef([]);
  const [preMove, setPreMove] = useState(null);

  // Overall state of the game
  const [game, setGame] = useState(new Chess(position));
  const [chessboardHeight, setChessboardHeight] = useState(0);
  const [tableId, setTableId] = useState(-1);
  const [showDrawRequest, setShowDrawRequest] = useState(false);
  const [drawRequestSent, setDrawRequestSent] = useState(false);
  const [showDrawReject, setShowDrawReject] = useState(false);
  const [showAbort, setShowAbort] = useState(false);

  const [showChallengeRequest, setShowChallengeRequest] = useState(false);
  const [showChallengeReject, setShowChallengeReject] = useState(false);
  const [showChallengeExpire, setShowChallengeExpire] = useState(false);
  const [showChallengeCancel, setShowChallengeCancel] = useState(false);
  const [showPlayerNotFound, setShowPlayerNotFound] = useState(false);
  const [showIncorrectHintModal, setShowIncorrectHintModal] = useState(false);

  const [challengeInProgress, setChallengeInProgress] = useState(false);

  const [ChallengeOpponent, setChallengeOpponent] = useState('');
  const [ChallengeMoveTimer, setChallengeMoveTimer] = useState('');
  const [ChallengeIncrement, setChallengeIncrement] = useState('');
  const [ChallengeVariantId, setChallengeVariantId] = useState('');
  const [ChallengePosition, setChallengePosition] = useState(
    'rnbqkbnr/pppppppp/8/8/8/8/PPPPPPPP/RNBQKBNR w KQkq - 0 1',
  );
  const [ChallengeWhite, setChallengeWhite] = useState('');

  const [searchPlayersResult, setSearchPlayersresult] = useState('');

  const [MoveTimer, setMoveTimer] = useState(180000);
  const [Increment, setIncrement] = useState(2000);

  const [showEndGameModal, setShowEndGameModal] = useState(false);
  const [showEngineEvaluatingModal, setShowEngineEvaluatingModal] =
    useState(false);
  const [endGameMessage, setEndGameMessage] = useState('');
  const [endType, setEndType] = useState('');

  const [myTime, setmyTime] = useState(null); //  seconds for white
  const [opponentTime, setopponentTime] = useState(null); //  seconds for black
  const [timerId, setTimerId] = useState(null);

  const [gameStartTime, setGameStartTime] = useState(5000);
  const [startTimer, setStartTimer] = useState(null);
  const [firstMoveTimer, setFirstMoveTimer] = useState(0);
  const [firstMovestartTimer, setFirstMoveStartTimer] = useState(null);
  const [searching, setSearching] = useState(false);

  // Notation component props
  const [moveClicked, setMoveClicked] = useState(false);
  const [moveSelected, setMoveSelected] = useState({});
  const [startfen, setStartfen] = useState(
    'rnbqkbnr/pppppppp/8/8/8/8/PPPPPPPP/RNBQKBNR w KQkq - 0 1',
  );

  const [customRules, setCustomRules] = useState([]);
  const [thinkingTime, SetThinkingTime] = useState(false);

  const [myRating, setmyRating] = useState(0); //  seconds for white
  const [opponentRating, setopponentRating] = useState(0);
  const [myRatingChange, setmyRatingChange] = useState(0); //  seconds for white
  const [opponentRatingChange, setopponentRatingChange] = useState(0);
  const [foundOpponent, SetFoundOpponent] = useState(false);
  const [gamestartSound] = useSound(gameStartSound);
  const [roundstartSound] = useSound(roundStartSound);
  const [winSound] = useSound(
    'https://cc-home.s3.ap-south-1.amazonaws.com/sound-effects/custom-app-move-sound/victory.mp3',
  );
  const [lossSound] = useSound(
    'https://cc-home.s3.ap-south-1.amazonaws.com/sound-effects/custom-app-move-sound/Defeat_pitch_shifted.mp3',
  );
  const [recievedDrawSound] = useSound(drawsound);
  const [MatchEndedInDrawSound] = useSound(
    'https://cc-home.s3.ap-south-1.amazonaws.com/sound-effects/custom-app-move-sound/Draw_pitch_shifted.mp3',
  );
  const [rejectDrawSound] = useSound(confirmation);
  //Assisted Gameplay
  const [hint, setHint] = useState('');
  const [hint2, setHint2] = useState('');
  const [moveIndex, setMoveIndex] = useState(0);
  const [showAssitedGameplay, setShowAssitedGameplay] = useState(false);
  const [playerComponentHeight, setPlayerComponentHeight] = useState(0);
  //TouchPiece control
  const [restrictedPiece, setRestrictedPiece] = useState('');
  const restrictedPieceRef = useRef(restrictedPiece);
  const [illegalTouchPieceCount, setIllegalTouchPieceCount] = useState(0);
  const [touchPieceControl, setTouchPieceControl] = useState(false);
  const onChessboardLayout = event => {
    const {height} = event.nativeEvent.layout;
    setChessboardHeight(height);
  };
  const onPlayerComponentLayout = event => {
    const {height} = event.nativeEvent.layout;
    setPlayerComponentHeight(height);
  };
  // 0: No game in progress
  // 1: Game in starting state
  // 2: Game in progress
  const [gameState, setGameState] = useState(0);

  const [tournamentId, setTournamentId] = useState(0);
  // tournamentIdRef re-sync. The sync effect declared ABOVE this useState
  // (near the top of the component) evaluates its `[tournamentId]` dep while
  // the const→var-hoisted binding is still undefined — on EVERY render — so
  // it only ever fired on mount and left the ref stuck at the initial 0
  // (breaking every consumer: the arena sends' arenaId, the arena envelope
  // guards, and the unmount room-leave). This effect sits after the
  // declaration, so its dep tracks the real value.
  useEffect(() => {
    tournamentIdRef.current = tournamentId;
    // new tournament ⇒ arm the arena auto-resume gate again
    arenaAutoResumedRef.current = false;
    // leave the previous tournament's broadcast room (see the
    // prevTournamentIdRef comment near sendStopWatchingTournament)
    const prev = prevTournamentIdRef.current;
    if (prev && prev !== tournamentId) {
      sendStopWatchingTournament(prev, clientRef.current);
    }
    prevTournamentIdRef.current = tournamentId;
  }, [tournamentId]);
  const [showTournamentPlay, setShowTournamentPlay] = useState(false);
  const [tournamentPlayersJoined, setTournamentPlayersJoined] = useState(0);
  const [activeTab, setActiveTab] = useState('details');
  const [round, setRound] = useState(1);
  const [roundEnd, setRoundEnd] = useState(0);
  const [roundStartTime, setRoundStartTime] = useState(0);
  const [tournamentEnded, setTournamentEnded] = useState(false);
  const [gamesEnded, setGamesEnded] = useState(0);
  // Throttles the standings/pairings refresh trigger so a burst of tournament
  // game-end broadcasts cannot fan out into an API-refetch storm.
  const gamesEndedThrottleRef = useRef({lastAt: 0, timer: null});
  const [joinMessage, setJoinMessage] = useState('');
  const [joinTnrSuccess, setJoinTnrSuccess] = useState(0);
  const [showTnrStarting, setShowTnrStarting] = useState(false);
  // 2026-05-19 sweep, bug 1: the cc-game-service `tournament_starting_soon`
  // envelope is now also used for cross-mode busy errors (e.g. "Opponent
  // is currently in another game" when the opponent is mid Fun Challenge).
  // Drive the modal copy from data.message when present; fall back to the
  // legacy tournament-specific string for old payload shapes.
  const [tnrStartingMessage, setTnrStartingMessage] = useState('');
  // Boolean to track if we're watching a game
  const [watchGame, setWatchGame] = useState(false);

  // Game state and moves
  const [watchGameState, setWatchGameState] = useState('');
  const [watchMoves, setWatchMoves] = useState([]);
  const [watchPrevGameState, setWatchPrevGameState] = useState('');
  const [watchState, setWatchState] = useState(0);

  // Player information
  const [watchWhite, setWatchWhite] = useState('');
  const [watchBlack, setWatchBlack] = useState('');
  const [watchWhiteUsername, setWatchWhiteUsername] = useState('');
  const [watchBlackUsername, setWatchBlackUsername] = useState('');
  const [watchWhiteRating, setWatchWhiteRating] = useState(0);
  const [watchBlackRating, setWatchBlackRating] = useState(0);

  // Time information
  const [watchWhiteTime, setWatchWhiteTime] = useState(0);
  const [watchBlackTime, setWatchBlackTime] = useState(0);
  const [watchPlayerMoveTimer, setWatchPlayerMoveTimer] = useState(0);
  const [watchMoveTimeIncrement, setWatchMoveTimeIncrement] = useState(0);

  // Game details
  const [watchTableId, setWatchTableId] = useState(null);
  const [watchCurrentPlayer, setWatchCurrentPlayer] = useState('');
  const [watchWhitePiecesCaptured, setWatchWhitePiecesCaptured] = useState([]);
  const [watchBlackPiecesCaptured, setWatchBlackPiecesCaptured] = useState([]);
  const [ongoingGames, setOngoingGames] = useState(0);
  const [isPairingGenerated, setIsPairingGenerated] = useState(false);
  const [tournamentStatusMessage, setTournamentStatusMessage] = useState('');
  const [tournamentState, setTournamentState] = useState('');
  console.log('schema', schema);
  const startGameStartCountdown = () => {
    const timerId = setInterval(updateGameStartCountdown, 1000);

    // Set a timeout to clear the interval after 25 seconds
    setTimeout(() => {
      clearInterval(timerId); // Clear the interval
      setGameState(prev => 2);
      setStartTimer(null); // Reset the timer state
    }, 2800); // 25 seconds

    // Store the timer ID in state for potential cleanup or future reference
    setStartTimer(timerId);
  };

  useEffect(() => {
    setShowChange(false);
    setGoodFeedback(0);
    setBadFeedback(0);
    // if (hint) {
    //   setShowIncorrectHintModal(true);
    // }
  }, [hint]);

  useEffect(() => {
    const updateLocalStorage = async () => {
      try {
        await setLocalStorage('moves', moves, false, () => {});
      } catch (error) {
        console.error('Failed to set localstorage for moves:', error);
      }
    };

    if (moves) {
      updateLocalStorage();
    }
  }, [moves]);

  const assistedGameplayRef = useRef(assistedGameplay);

  useEffect(() => {
    assistedGameplayRef.current = assistedGameplay;
  }, [assistedGameplay]);

  const lastMoveRef = useRef(lastMove);

  useEffect(() => {
    lastMoveRef.current = lastMove;
  }, [lastMove]);

  function getAssistedGameMoveAnalysis(
    userid,
    move,
    fen,
    color,
    last_fen,
    player,
    uuid,
    move_index,
  ) {
    if (assistedGameplayRef.current) {
      setUuid(uuid);
      AssistedGameMoveAnalysis({
        userid,
        move,
        fen,
        color,
        last_fen,
        player,
        uuid,
        move_index,
      });
    }
  }

  const updateGameStartCountdown = () => {
    let currentCountDown = 0;
    setGameStartTime(prevTime => {
      currentCountDown = prevTime - 1000;
      return prevTime - 1000;
    });
    if (currentCountDown == 0) {
      setStartTimer(timer => {
        clearInterval(timer);
        setGameState(prev => 2);
        return timer;
      });
    }
  };

  const stopTimer = () => {
    clearInterval(timerId); // Clear the interval
    setTimerId(null); // Reset timer ID
  };

  function formatTime(seconds) {
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = seconds % 60;
    const formattedMinutes = String(minutes).padStart(2, '0');
    const formattedSeconds = String(remainingSeconds).padStart(2, '0');
    return `${formattedMinutes}:${formattedSeconds}`;
  }

  const CCApplicationClient = async () => {
    if (isStaff && username) {
      console.log('Async .. Logging in with username: ', username, accessToken);
      let tableid;
      let white;
      let total_time;
      let cc_playing;

      const cc_client = socket;

      // Register schemas and handlers using new registerMessageType and registerMessageHandler

      if (startGameResponseCallback) {
        cc_client.registerMessageType(
          'start_game_response',
          schema.startGameResMsgSchema,
        );
        cc_client.registerMessageHandler(
          'start_game_response',
          function (socket, data) {
            // console.log('*** startGameResponseCallback = ', data);
            startGameResponseCallback(socket, data);
          },
          'PlayChess:start_game_response',
        );
      }

      if (registerJoinGameSchema) {
        cc_client.registerMessageType(
          'join_game_request',
          schema.joinGameReqMsgSchema,
        );
        cc_client.registerMessageHandler(
          'join_game_request',
          function (socket, data) {
            registerJoinGameSchema(socket, data);
          },
          'PlayChess:join_game_request',
        );
      }

      if (registerLeaveTableSchema) {
        cc_client.registerMessageType(
          'leave_table_request',
          schema.leaveTableReqMsgSchema,
        );
        cc_client.registerMessageHandler(
          'leave_table_request',
          function (socket, data) {
            registerLeaveTableSchema(socket, data);
          },
          'PlayChess:leave_table_request',
        );
      }


      if (challengeCancelCallback) {
        cc_client.registerMessageType(
          'challenge_cancel',
          schema.challengeGameMsgSchema,
        );
        cc_client.registerMessageHandler(
          'challenge_cancel',
          function (socket, data) {
            challengeCancelCallback(socket, data);
          },
          'PlayChess:challenge_cancel',
        );
      }

      if (registerChallengeRequest) {
        cc_client.registerMessageType(
          'challenge_game_request',
          schema.challengeGameMsgSchema,
        );
        cc_client.registerMessageHandler(
          'challenge_game_request',
          function (socket, data) {
            // console.log('About to call challenge response message handler ... ');
            registerChallengeRequest(socket, data);
          },
          'PlayChess:challenge_game_request',
        );
      }

      if (joinGameResponseCallback) {
        cc_client.registerMessageType(
          'join_game_response',
          schema.joinGameResMsgSchema,
        );
        cc_client.registerMessageHandler(
          'join_game_response',
          function (socket, data) {
            joinGameResponseCallback(socket, data);
          },
          'PlayChess:join_game_response',
        );
      }

      if (gameReadyResponseCallback) {
        cc_client.registerMessageType(
          'game_ready_response',
          schema.gameReadyResMsgSchema,
        );
        cc_client.registerMessageHandler(
          'game_ready_response',
          function (socket, data) {
            gameReadyResponseCallback(socket, data);
          },
          'PlayChess:game_ready_response',
        );
      }

      // if (preStartGameResponseCallback) {
      //   cc_client.registerMessageType('pre_start_game', schema.preStartGameMsgSchema);
      //   cc_client.registerMessageHandler('pre_start_game', function (socket, data) {
      //     preStartGameResponseCallback(socket, data);
      //   });
      // }

      if (playerTurnResponseCallback) {
        cc_client.registerMessageType(
          'player_turn_response',
          schema.eventResMsgSchema,
        );
        cc_client.registerMessageHandler(
          'player_turn_response',
          function (socket, data) {
            playerTurnResponseCallback(socket, data);
          },
          'PlayChess:player_turn_response',
        );
      }

      if (registerPlayerMoveSchema) {
        cc_client.registerMessageType('player_move', schema.moveResMsgSchema);
        cc_client.registerMessageHandler(
          'player_move',
          function (socket, data) {
            registerPlayerMoveSchema(socket, data);
          },
          'PlayChess:player_move',
        );
      }

      if (startGameCallback) {
        cc_client.registerMessageType('start_game', schema.startGameMsgSchema);
        cc_client.registerMessageHandler('start_game', function (socket, data) {
          startGameCallback(socket, data);
        }, 'PlayChess:start_game');
      }

      if (drawCheckResponseCallback) {
        cc_client.registerMessageType('draw_check', schema.drawCheckMsgSchema);
        cc_client.registerMessageHandler('draw_check', function (socket, data) {
          drawCheckResponseCallback(socket, data);
        }, 'PlayChess:draw_check');
      }

      if (drawRejectedCallback) {
        cc_client.registerMessageType(
          'draw_reject',
          schema.drawRejectMsgSchema,
        );
        cc_client.registerMessageHandler(
          'draw_reject',
          function (socket, data) {
            drawRejectedCallback(socket, data);
          },
          'PlayChess:draw_reject',
        );
      }

      // if (challengeRequestCallback) {
      //   console.log('Inside challenge Request Check .. ');
      //   cc_client.registerMessageType('challenge_request_check', schema.challengeGameMsgSchema);
      //   cc_client.registerMessageHandler('challenge_request_check', function (socket, data) {
      //     console.log('Inside challenge_request_check .... ');
      //     challengeRequestCallback(socket, data);
      //   });
      // }

      if (challengeRejectedCallback) {
        cc_client.registerMessageType(
          'challenge_reject',
          schema.challengeGameMsgSchema,
        );
        cc_client.registerMessageHandler(
          'challenge_reject',
          function (socket, data) {
            challengeRejectedCallback(socket, data);
          },
          'PlayChess:challenge_reject',
        );
      }

      if (challengeExpiredCallback) {
        cc_client.registerMessageType(
          'challenge_request_expire',
          schema.challengeGameMsgSchema,
        );
        cc_client.registerMessageHandler(
          'challenge_request_expire',
          function (socket, data) {
            challengeExpiredCallback(socket, data);
          },
          'PlayChess:challenge_request_expire',
        );
      }

      if (registerOnlinePlayersSearchSchema) {
        cc_client.registerMessageType(
          'online_players_search',
          schema.onlinePlayersSearchMsgSchema,
        );
        cc_client.registerMessageHandler(
          'online_players_search',
          function (socket, data) {
            registerOnlinePlayersSearchSchema(socket, data);
          },
          'PlayChess:online_players_search',
        );
      }

      if (registerFetchGameStateSchema) {
        cc_client.registerMessageType(
          'fetch_game_state',
          schema.fetchGameStateMsgSchema,
        );
        cc_client.registerMessageHandler(
          'fetch_game_state',
          function (socket, data) {
            registerFetchGameStateSchema(socket, data);
          },
          'PlayChess:fetch_game_state',
        );
      }

      if (onlinePlayersSearchResult) {
        cc_client.registerMessageType(
          'online_players_result',
          schema.onlinePlayersResultMsgSchema,
        );
        cc_client.registerMessageHandler(
          'online_players_result',
          function (socket, data) {
            console.log('Online players result = ', JSON.stringify(data));
            onlinePlayersSearchResult(socket, data);
          },
          'PlayChess:online_players_result',
        );
      }

      if (gameEndResponseCallback) {
        cc_client.registerMessageType(
          'game_end_response',
          schema.gameEndResMsgSchema,
        );
        cc_client.registerMessageHandler(
          'game_end_response',
          function (socket, data) {
            gameEndResponseCallback(socket, data);
          },
          'PlayChess:game_end_response',
        );
      }

      if (tournamentOpeningPrepEvalPendingResponseCallback) {
        cc_client.registerMessageType(
          'tournament_opening_prep_eval_pending_response',
          schema.tournamentOpeningPrepEvalPendingResMsgSchema,
        );
        cc_client.registerMessageHandler(
          'tournament_opening_prep_eval_pending_response',
          function (socket, data) {
            tournamentOpeningPrepEvalPendingResponseCallback(socket, data);
          },
          'PlayChess:tournament_opening_prep_eval_pending_response',
        );
      }

      cc_client.registerMessageType(
        'join_tournament_request',
        schema.joinTournamentReqMsgSchema,
      );

      cc_client.registerMessageType(
        'join_tournament_response',
        schema.joinTournamentResMsgSchema,
      );

      cc_client.registerMessageType(
        'end_game_confirmed',
        schema.endGameConfirmSchema,
      );

      cc_client.registerMessageType(
        'tournament_starting_soon',
        schema.tournamentStartingSchema,
      );

      if (handleTournamentStartingSoon) {
        cc_client.registerMessageHandler(
          'tournament_starting_soon',
          function (socket, data) {
            handleTournamentStartingSoon(socket, data);
          },
          'PlayChess:tournament_starting_soon',
        );
      }

      if (joinTournamentResponseCallback) {
        cc_client.registerMessageHandler(
          'join_tournament_response',
          function (socket, data) {
            joinTournamentResponseCallback(socket, data);
          },
          'PlayChess:join_tournament_response',
        );
      }

      cc_client.registerMessageType(
        'withdraw_tournament_request',
        schema.withDrawTournamentReqMsgSchema,
      );

      cc_client.registerMessageType(
        'withdraw_tournament_response',
        schema.withDrawTournamentResMsgSchema,
      );

      if (withdrawPlayerResponseCallback) {
        cc_client.registerMessageHandler(
          'withdraw_tournament_response',
          function (socket, data) {
            withdrawPlayerResponseCallback(socket, data);
          },
          'PlayChess:withdraw_tournament_response',
        );
      }

      cc_client.registerMessageType(
        'tournament_end_response',
        schema.tournamentEndResMegSchema,
      );

      if (tournamentEndResponseCallback) {
        cc_client.registerMessageHandler(
          'tournament_end_response',
          function (socket, data) {
            tournamentEndResponseCallback(socket, data);
          },
          'PlayChess:tournament_end_response',
        );
      }

      cc_client.registerMessageType(
        'pairing',
        schema.tournamentPairingBroadcastSchema,
      );

      cc_client.registerMessageType(
        'tournament_status_response',
        schema.tournamentPairingBroadcastSchema,
      );

      cc_client.registerMessageType(
        'get_tournament_status',
        schema.getTournamentStatusMsgSchema,
      );

      cc_client.registerMessageType(
        'stop_watching_tournament_request',
        schema.stopWatchingTournamentMsgSchema,
      );

      if (tournamentStatusResponseCallback) {
        cc_client.registerMessageHandler(
          'tournament_status_response',
          function (socket, data) {
            tournamentStatusResponseCallback(socket, data);
          },
          'PlayChess:tournament_status_response',
        );
      }

      if (pairingCallback) {
        cc_client.registerMessageHandler('pairing', function (socket, data) {
          pairingCallback(socket, data);
        }, 'PlayChess:pairing');
      }

      cc_client.registerMessageType(
        'no_ongoing_game',
        schema.emptyGameStateSchema,
      );

      if (handleEmptyGameState) {
        cc_client.registerMessageHandler(
          'no_ongoing_game',
          function (socket, data) {
            handleEmptyGameState(socket, data);
          },
          'PlayChess:no_ongoing_game',
        );
      }

      console.info('events are..', schema);

      cc_client.registerMessageType(
        'watch_tournament_game_request',
        schema.watchTournamentGameReqMsgSchema,
      );
      console.log('events are..', schema);
      cc_client.registerMessageType(
        'watch_tournament_game_response',
        schema.watchTournamentGameResMsgSchema,
      );

      cc_client.registerMessageType(
        'stop_watching_tournament_game_request',
        schema.stopWatchingTournamentGameReqMsgSchema,
      );

      cc_client.registerMessageType(
        'stop_watching_tournament_game_response',
        schema.stopWatchingTournamentGameResMsgSchema,
      );

      cc_client.registerMessageType(
        'watch_player_turn_response',
        schema.watchPlayerTurnResMsgSchema,
      );

      cc_client.registerMessageType(
        'watch_game_end_response',
        schema.gameEndResMsgSchema,
      );

      cc_client.registerMessageType(
        'bye_response',
        schema.tournamentByeMsgSchema,
      );

      cc_client.registerMessageType(
        'tournament_game_end_response',
        schema.tournamentPairingBroadcastSchema,
      );

      if (WatchPlayerTurnResponseCallback) {
        cc_client.registerMessageHandler(
          'watch_player_turn_response',
          function (socket, data) {
            WatchPlayerTurnResponseCallback(socket, data);
          },
          'PlayChess:watch_player_turn_response',
        );
      }

      if (byeResponseCallback) {
        cc_client.registerMessageHandler(
          'bye_response',
          function (socket, data) {
            byeResponseCallback(socket, data);
          },
          'PlayChess:bye_response',
        );
      }

      if (WatchGameEndResponseCallback) {
        cc_client.registerMessageHandler(
          'watch_game_end_response',
          function (socket, data) {
            WatchGameEndResponseCallback(socket, data);
          },
          'PlayChess:watch_game_end_response',
        );
      }

      if (TournamentGameEndResponseCallback) {
        cc_client.registerMessageHandler(
          'tournament_game_end_response',
          function (socket, data) {
            TournamentGameEndResponseCallback(socket, data);
          },
          'PlayChess:tournament_game_end_response',
        );
      }

      if (watchTournamentGameResponseCallback) {
        cc_client.registerMessageHandler(
          'watch_tournament_game_response',
          function (socket, data) {
            watchTournamentGameResponseCallback(socket, data);
          },
          'PlayChess:watch_tournament_game_response',
        );
      }

      if (stopWatchingTournamentGameResponseCallback) {
        cc_client.registerMessageHandler(
          'stop_watching_tournament_game_response',
          function (socket, data) {
            stopWatchingTournamentGameResponseCallback(socket, data);
          },
          'PlayChess:stop_watching_tournament_game_response',
        );
      }

      // ── Arena tournaments ──────────────────────────────────────────────
      // All 7 arena_* messages share ONE schemapack schema
      // (requestId/type/arenaId/tableId/payload — payload is a JSON string).
      // Guarded on the SDK actually exporting it so an older installed
      // cc-client-sdk cannot break the rest of the gameplay surface.
      if (schema.arenaEnvelopeSchema) {
        [
          'arena_resume_request',
          'arena_pause_request',
          'arena_status_request',
          'arena_berserk_request',
          'arena_status_response',
          'arena_standings_response',
          'arena_berserk_response',
        ].forEach(arenaType =>
          cc_client.registerMessageType(arenaType, schema.arenaEnvelopeSchema),
        );

        cc_client.registerMessageHandler(
          'arena_status_response',
          function (socket, data) {
            arenaStatusResponseCallback(socket, data);
          },
          'PlayChess:arena_status_response',
        );

        cc_client.registerMessageHandler(
          'arena_standings_response',
          function (socket, data) {
            arenaStandingsResponseCallback(socket, data);
          },
          'PlayChess:arena_standings_response',
        );

        cc_client.registerMessageHandler(
          'arena_berserk_response',
          function (socket, data) {
            arenaBerserkResponseCallback(socket, data);
          },
          'PlayChess:arena_berserk_response',
        );
      } else {
        console.warn(
          'cc-client-sdk does not export arenaEnvelopeSchema — arena tournaments disabled on this client',
        );
      }

      setClient(cc_client);
      setIsConnected(cc_client.connected);

      cc_client.on('disconnect', function () {
        setIsConnected(false);
      });

      cc_client.on('connect', function () {
        setIsConnected(true);
      });

      cc_client.on('close', function () {
        setIsConnected(false);
      });

      function byeResponseCallback(socket, data) {
        console.info(
          '... bye tournament response event .. ',
          JSON.stringify(data),
          socket.id,
        );
        getTournamentStatus(data?.tournamentId);
        setEndGameMessage('You have recieved a Bye in this Round!');
        setResult('Win');
        setEndType('');
        setShowEndGameModal(true);
      }

      function joinTournamentResponseCallback(socket, data) {
        console.info(
          '... join tournament response event .. ',
          JSON.stringify(data),
          socket.id,
        );
        if (data?.playerId == username) {
          switch (data?.success) {
            case false:
              if (data?.message?.toLowerCase()?.includes('already')) {
                setJoinTnrSuccess(0);
                break;
              }
              setJoinTnrSuccess(1);
              setJoinMessage(data?.message);
              break;
            case true:
              setJoinTnrSuccess(2);
              break;
            default:
              setJoinTnrSuccess(0);
          }
        }

        if (data.requestId == 'reload_screen') {
          getTournamentDetails(data.tournamentId);
        }
        setTournamentPlayersJoined(prevCount => prevCount + 1);
        if (data.playerId == username) {
          gameplayStore.setJoinedTournament(true);
          gameplayStore.setJoinedTournamentId(data.tournamentId);
        }
      }

      function handleEmptyGameState(socket, data) {
        console.info(
          '... empty game state event ..',
          JSON.stringify(data),
          socket.id,
        );
        setStarted(false);
        setPosition('rnbqkbnr/pppppppp/8/8/8/8/PPPPPPPP/RNBQKBNR w KQkq - 0 1');
        setShowAssitedGameplay(false);
        // setGamePlayMode('Play');
        setAssistedGameplay(false);
        setPlaying(false);
      }

      function handleTournamentStartingSoon(socket, data) {
        console.info(
          '... tournament starting soon event ..',
          JSON.stringify(data),
          socket.id,
        );
        setSearching(false);
        setChallengeInProgress(false);
        setTnrStartingMessage(
          typeof data?.message === 'string' && data.message.trim()
            ? data.message
            : '',
        );
        setShowTnrStarting(true);
      }

      function withdrawPlayerResponseCallback(socket, data) {
        console.info(
          '... withdraw player response event .. ',
          JSON.stringify(data),
          socket.id,
        );
        if (data.playerId == username) {
          gameplayStore.setJoinedTournament(false);
          gameplayStore.setJoinedTournamentId('0');
        }
        setTournamentPlayersJoined(prevCount => Math.max(prevCount - 1, 0));
      }

      function tournamentStatusResponseCallback(socket, data) {
        console.info(
          '... tournament status response event ..',
          JSON.stringify(data),
          socket.id,
        );
        setTournamentState(data?.roundState);
        setTournamentStatusMessage(data?.message);
        setOngoingGames(data?.ongoing_games);
        setRound(data?.round);
      }

      function pairingCallback(socket, data) {
        console.info('... pairing event .. ', JSON.stringify(data), socket.id);
        // After pairing generated
        if (data?.roundState === 'pairings_generated') {
          setIsPairingGenerated(true);
          setRoundEnd(0);
        } else if (data?.roundState === 'generating_pairings') {
          setRoundEnd(1);
        }

        setTournamentState(data?.roundState);
        setTournamentStatusMessage(data?.message);
        setOngoingGames(data?.ongoing_games);

        setShowTournamentPlay(true);
        gameplayStore.setTournamentPlay(true);
        setWatchGame(false);

        // setStarted(false)
        setShowEndGameModal(false);
        setActiveTab('standings');
        if (data.round > 1) {
          // setRoundEnd(1);
          setRound(data.round);
          setTimeout(() => {
            setActiveTab('games');
            roundstartSound();
            // const roundStartTime = new Date().getTime() + 7000; // 10 seconds from now
            // console.log('Round will start at:', new Date(roundStartTime)); // Debugging log
            // setRoundStartTime(roundStartTime);
            // setRoundEnd(0);
          }, 100);
        } else {
          roundstartSound();
          setActiveTab('games');
          setRound(data.round);
          // const roundStartTime = new Date().getTime() + 10000; // 10 seconds from now
          // console.log('Round will start at:', new Date(roundStartTime)); // Debugging log
          // setRoundStartTime(roundStartTime);
          // setRoundEnd(0);
        }
        setTimeout(() => {
          setRoundStartTime(0);
        }, 11000);
        setTimeout(() => {
          setGamesEnded(prevCount => prevCount + 1);
        }, 15000);
        setPosition('rnbqkbnr/pppppppp/8/8/8/8/PPPPPPPP/RNBQKBNR w KQkq - 0 1');
      }

      function tournamentEndResponseCallback(socket, data) {
        console.info(
          '... end tournament response event .. ',
          JSON.stringify(data),
          socket.id,
        );
        setTournamentEnded(true);
        setShowTournamentPlay(true);
        // Tournament is over — user is no longer in active tournament play, so
        // release the challenge-blocking gate. Previously this set it to `true`,
        // which left challenges suppressed for the rest of the session even
        // after the tournament ended.
        gameplayStore.setTournamentPlay(false);
        setStarted(false);
        setShowEndGameModal(false);
        setActiveTab('standings');
        setTournamentPlayersJoined(prevCount => prevCount + 1);
        gameplayStore.setJoinedTournament(false);
        gameplayStore.setJoinedTournamentId('0');
        setWatchGame(false);
      }

      function watchTournamentGameResponseCallback(socket, data) {
        console.info(
          '... watch tournament game response event .. ',
          JSON.stringify(data),
          socket.id,
        );
        setWatchGame(true);
        setActiveTab('notation');
        setStartFenTournament(data.startFen);

        // Set game state and moves
        setWatchGameState(data.gameState);
        setWatchState(data.state);
        setTournamentMoves(data.moves || []);
        // broadcast-delta: this is the full watch snapshot — seed the tracker.
        watchMovesSanRef.current = (data.moves || []).map(m =>
          m && typeof m === 'object' ? m.move : m,
        );
        setWatchPrevGameState(data.prevGameState || '');

        // Set player information
        setWatchWhite(data.white);
        setWatchBlack(data.black);
        setWatchWhiteUsername(data.whiteUsername);
        setWatchBlackUsername(data.blackUsername);
        setWatchWhiteRating(data.whiteRating);
        setWatchBlackRating(data.blackRating);

        // Set time information
        setWatchWhiteTime(Math.round(data.whiteTime / 1000));
        setWatchBlackTime(Math.round(data.blackTime / 1000));
        setWatchPlayerMoveTimer(data.playerMoveTimer);
        setWatchMoveTimeIncrement(data.moveTimeIncrement);

        // Set game details
        setWatchTableId(data.tableId);
        setWatchCurrentPlayer(data.currentPlayer);
        setWatchWhitePiecesCaptured(
          (data.whitePiecesCaptured || []).map(letter => letter.toUpperCase()),
        );
        setWatchBlackPiecesCaptured(
          (data.blackPiecesCaptured || []).map(letter => letter.toUpperCase()),
        );
        setIllegalTouchPieceCount(prevCount => prevCount + 1)
      }

      function WatchPlayerTurnResponseCallback(socket, data) {
        console.info(
          '... watch player turn response event .. ',
          JSON.stringify(data),
          socket.id,
        );
        setWatchCurrentPlayer(data.userId);
        setWatchBlackTime(Math.round(data.blackTime));
        setWatchWhiteTime(Math.round(data.whiteTime));
        setWatchGameState(data.data);
        // broadcast-delta: a live watch turn carries only the new move; re-expand
        // from the watch tracker into the full list the renderer expects.
        if (Array.isArray(data.moves)) {
          const deltaSan = data.moves.map(m =>
            m && typeof m === 'object' ? m.move : m,
          );
          data.moves = [...watchMovesSanRef.current, ...deltaSan];
          watchMovesSanRef.current = data.moves.slice();
        }
        setTournamentMoves(
          (data.moves || []).map(move =>
            move && typeof move === 'object'
              ? {...move, matched: false, isHumanMove: false}
              : {move, matched: false, isHumanMove: false},
          ),
        );
        setWatchPrevGameState(data.previousFen || '');
        setWatchWhitePiecesCaptured(
          (data.whitePiecesCaptured || []).map(letter => letter.toUpperCase()),
        );
        setWatchBlackPiecesCaptured(
          (data.blackPiecesCaptured || []).map(letter => letter.toUpperCase()),
        );

      }
        

      function WatchGameEndResponseCallback(socket, data) {
        console.info(
          '... watch gameEnd response event .. ',
          JSON.stringify(data),
          socket.id,
        );
        setWatchState(8);
        setWatchGameState(data?.gameState);
        setEndType(data.endType);
        if (
          data.endType == 'draw' ||
          data.endType == 'stalemate' ||
          data.endType == 'insufficient' ||
          data.endType == 'repetition'
        ) {
          setResult('Draw');
          setEndGameMessage('The match ended in a draw.');
        } else if (data.endType == 'abort') {
          setResult('Abort');
          setEndGameMessage('The match was aborted.');
          setmyRatingChange(0);
          setopponentRatingChange(0);
        } else {
          setResult('Win');
          if (data.winner == data.white) {
            setEndGameMessage('White won the match!');
          } else {
            setEndGameMessage('Black won the match!');
          }
        }
        setTournamentMoves(
          (data.moves || []).map(move =>
            move && typeof move === 'object'
              ? {...move, matched: false, isHumanMove: false}
              : {move, matched: false, isHumanMove: false},
          ),
        );
        setWatchWhitePiecesCaptured(
          (data.whitePiecesCaptured || []).map(letter => letter.toUpperCase()),
        );
        setWatchBlackPiecesCaptured(
          (data.blackPiecesCaptured || []).map(letter => letter.toUpperCase()),
        );
        setTimeout(() => {
          setShowEndGameModal(true);
        }, 1500);
      }

      function TournamentGameEndResponseCallback(socket, data) {
        console.info(
          '... tournament game end response event .. ',
          JSON.stringify(data),
          socket.id,
        );
        // Cheap local-state updates stay live (real-time ongoing-games count).
        setIsPairingGenerated(false);
        setOngoingGames(data?.ongoing_games || 0);
        setTournamentState(data?.roundState);
        setTournamentStatusMessage(data?.message);
        // `gamesEnded` drives standings/pairings refetches. Game-end broadcasts
        // arrive ~1/sec during a round; bumping per broadcast caused an API
        // storm across every client in the tournament. Throttle to one bump
        // per ~10-15s (jittered so clients don't refetch in lockstep).
        const geThrottle = gamesEndedThrottleRef.current;
        const geNow = Date.now();
        const geInterval = 10000 + Math.floor(Math.random() * 5000);
        if (geNow - geThrottle.lastAt >= geInterval) {
          geThrottle.lastAt = geNow;
          setGamesEnded(prevCount => prevCount + 1);
        } else if (!geThrottle.timer) {
          geThrottle.timer = setTimeout(() => {
            geThrottle.lastAt = Date.now();
            geThrottle.timer = null;
            setGamesEnded(prevCount => prevCount + 1);
          }, geInterval - (geNow - geThrottle.lastAt));
        }
      }

      function stopWatchingTournamentGameResponseCallback(socket, data) {
        console.info(
          '... stop watching tournament game response event .. ',
          JSON.stringify(data),
          socket.id,
        );
        setWatchGame(false);
        setWatchState(0);

        // Reset game state and moves
        setWatchGameState('');
        setWatchMoves([]);
        setWatchPrevGameState('');

        // Reset player information
        setWatchWhite('');
        setWatchBlack('');
        setWatchWhiteUsername('');
        setWatchBlackUsername('');
        setWatchWhiteRating(0);
        setWatchBlackRating(0);

        // Reset time information
        setWatchWhiteTime(0);
        setWatchBlackTime(0);
        setWatchPlayerMoveTimer(0);
        setWatchMoveTimeIncrement(0);

        // Reset game details
        setWatchTableId(null);
        setWatchCurrentPlayer('');
        setWatchWhitePiecesCaptured([]);
        setWatchBlackPiecesCaptured([]);
        setGameId('');
      }

      // ── Arena handlers — payload is a JSON string on the shared envelope ─
      function parseArenaPayload(data) {
        try {
          return JSON.parse(data?.payload || '{}') || {};
        } catch (e) {
          console.warn('bad arena payload:', e?.message);
          return {};
        }
      }

      function arenaStatusResponseCallback(socket, data) {
        console.info(
          '... arena status response event .. ',
          JSON.stringify(data),
          socket.id,
        );
        // Drop events for a different arena (stale room subscription /
        // multi-tab): the envelope arenaId must match the tournament we're on.
        if (String(data?.arenaId) !== String(tournamentIdRef.current)) {
          return;
        }
        useArenaStore.getState().setStatus(parseArenaPayload(data));
      }

      function arenaStandingsResponseCallback(socket, data) {
        console.info(
          '... arena standings response event .. ',
          JSON.stringify(data),
          socket.id,
        );
        if (String(data?.arenaId) !== String(tournamentIdRef.current)) {
          return;
        }
        const payload = parseArenaPayload(data);
        // A JSON.parse failure yields {} — never wipe good standings with it.
        if (!payload || !payload.entries) {
          return;
        }
        useArenaStore.getState().setStandings(payload);
      }

      function arenaBerserkResponseCallback(socket, data) {
        console.info(
          '... arena berserk response event .. ',
          JSON.stringify(data),
          socket.id,
        );
        // Same arena guard as status/standings — except refusals, which
        // arrive 1:1 with an EMPTY arenaId, so an empty id passes through.
        if (
          data?.arenaId &&
          String(data.arenaId) !== String(tournamentIdRef.current)
        ) {
          return;
        }
        const payload = parseArenaPayload(data);
        const isMe = String(payload.userId) === String(username);
        // Success is broadcast to the whole table (and watch room); only act
        // on OUR seated table so a watched game can't pollute our flags.
        // Compared against the ref (not the CCApplicationClient closure
        // `tableid`, which resets when that effect re-runs mid-game).
        const isMyTable =
          data?.tableId &&
          String(data.tableId) === String(arenaTableIdRef.current);
        if (!isMe && !isMyTable) {
          return;
        }
        useArenaStore.getState().setBerserk(payload.userId, payload, username);
        if (payload.refused) {
          console.info('berserk refused:', payload.refused);
          if (isMe) {
            const refusalMessages = {
              'window-closed': 'Berserk window closed',
              'clock-too-short': 'Clock too short to berserk',
            };
            showToast(
              refusalMessages[payload.refused] ||
                'Berserk unavailable right now',
              {duration: 4000},
            );
          }
          return;
        }
        // Halve the displayed clock of the player who berserked. The live
        // clock state (whiteTime/blackTime, fed by player_turn_response) is in
        // SECONDS (gameEventHandler broadcasts Math.round(ms/1000));
        // newClockMs is milliseconds.
        if (isMyTable && payload.newClockMs != null) {
          const newClockSeconds = Math.round(payload.newClockMs / 1000);
          if (String(payload.userId) === String(white)) {
            setWhiteTime(newClockSeconds);
          } else {
            setBlackTime(newClockSeconds);
          }
        }
      }

      function startGameResponseCallback(socket, data) {
        console.info(
          '... start game response event .. ',
          JSON.stringify(data),
          socket.id,
        );

        setWatchGame(false);
        setGameId('')
        setPlaying(true);
        gameplayStore.setPlaying(true);
        cc_playing = true;

        setShowEndGameModal(false);
        setShowChallengeReject(false);
        setShowChallengeExpire(false);
        setShowChallengeCancel(false);

        // console.log('Received TableID = ', data?.tableId);
        setTableId(data?.tableId);
        tableid = data.tableId;
        // ref survives CCApplicationClient re-runs (see arenaTableIdRef)
        arenaTableIdRef.current = data?.tableId;

        white = data.tossWinner;
        const player1 = data.playerList[0].split(':')[0];
        const player2 = data.playerList[1].split(':')[0];

        const black = player1 == white ? player2 : player1;

        setWhitePlayer(white); // white player
        setBlackPlayer(black);

        total_time = data.playerMoveTimer / 1000;
        setFirstMoveTimer(
          data.gamePlayMode == 'tournament' || data.gamePlayMode == 'arena'
            ? total_time / 2
            : data.startFen ==
              'rnbqkbnr/pppppppp/8/8/8/8/PPPPPPPP/RNBQKBNR w KQkq - 0 1'
            ? total_time - 20
            : total_time - 30,
        );
        let parsedTouchPiece = data.touchPiece
          ? JSON.parse(data.touchPiece)
          : '';

        setTimeout(() => {
          setRestrictedPiece(parsedTouchPiece);
        }, 1200);
        setGamePlayMode(data?.gamePlayMode);
        console.info('inside start game response event handler 1');
        // Arena spawns arrive with gamePlayMode == 'arena' (NOT 'tournament');
        // without this extension the else-branch dropped showTournamentPlay and
        // skipped all tournament board setup, stranding arena players after
        // their first auto-paired game.
        if (data.gamePlayMode == 'tournament' || data.gamePlayMode == 'arena') {
          setIsPairingGenerated(false);
          // setRoundEnd(0);
          setActiveTab('notation');
          setTournamentId(data.tournamentId);
          getTournamentDetails(data.tournamentId);
          getTournamentStatus(data.tournamentId);
          // setRound(data.round);
          if (data.gamePlayMode == 'arena' || isArenaRef.current) {
            // fresh arena game — clear the previous game's berserk badges
            useArenaStore.getState().resetGameBerserk();
            // Optimistic myState — the server pushes a 1:1 status_response
            // with myState 'paired' right after the spawn, but stamping it
            // locally (setStatus merges) closes the round-trip gap so the
            // lobby card can never say "Finding your next game…" while this
            // board is live. Game end re-requests status (sendArenaStatus).
            useArenaStore.getState().setStatus({myState: 'paired'});
          }
        } else {
          setShowTournamentPlay(false);
        }

        if (data.requestId == 'On reconnect' || data.requestId == 'On fetch') {
          setOpponentDisplayName(data.opponentusername);
          setopponentRating(data.opponentRating);
          setStartfen(data.startFen);
          console.info('inside start game response event handler 2');
          if (data.startFen.split(' ')[1] == 'b') {
            setIsBlackTurnFirst(true);
          }
          setGamePlayMode(data.gamePlayMode);
          if (data.gamePlayMode == 'Play and Learn') {
            setAssistedGameplay(true);
          } else {
            setAssistedGameplay(false);
          }

          let rated = data.gamePlayMode == 'Play' ? 'Rated' : 'Unrated';
          if (
            data.opponentusername.startsWith('Caissa') ||
            data.startFen !==
              'rnbqkbnr/pppppppp/8/8/8/8/PPPPPPPP/RNBQKBNR w KQkq - 0 1'
          ) {
            rated = 'Unrated';
          }
          setGameDetails(
            `${data.playerMoveTimer / 60000} + ${
              data.moveTimeIncrement / 1000
            } • ${rated} • ${classifyTimeControl(
              data.playerMoveTimer,
              data.moveTimeIncrement,
            )}`,
          );
        }

        setMyTurn(username == white);
        console.log('Awaiting player turn .. ');
      }

      // cc_client.registerMessageType('join_game_request', schema.joinGameReqMsgSchema, function (socket, data) {
      //     cc_client.username = username;
      // });

      function registerJoinGameSchema(socket, data) {
        client.username = username;
      }

      // cc_client.registerMessageType('leave_table_request', schema.leaveTableReqMsgSchema, function (socket, data) {
      //     cc_client.username = username;
      // });

      function registerLeaveTableSchema(socket, data) {
        console.info(
          '...leave game response message data...',
          JSON.stringify(data),
          socket.id,
        );
        setTimeout(()=>{
          handle_new_game();
        },2000)
        
      }

      function challengeCancelCallback(socket, data) {
        console.info(
          '...challenge_cancel message data...',
          JSON.stringify(data),
          socket.id,
        );

        cc_client.username = username;
        setShowChallengeCancel(true && !cc_playing);
        gameplayStore?.setShowChallengeCancel(true);
        setShowChallengeRequest(false);
      }

      // cc_client.registerMessageType('challenge_game_request', schema.challengeGameMsgSchema, function (socket, data) {
      //     cc_client.username = username;
      //     console.log('...challenge_cancel message data...', data);
      //     setShowChallengeCancel(true);
      //     setShowChallengeRequest(false);
      // });

      function registerChallengeRequest(socket, data) {
        cc_client.username = username;

        setShowChallengeCancel(true);
        setShowChallengeRequest(false);
      }

      function joinGameResponseCallback(socket, data) {
        joinGameHandler(data);
        console.log('Received TableID = ', data?.tableId);
        setTableId(data?.tableId);
      }

      function gameReadyResponseCallback(socket, data) {
        // already seated on new table
        setTimeout(() => {
          gamestartSound();
        }, 1500);
        SetFoundOpponent(true);
        setGameStartTime(2000);
        setRoundStartTime(0);
        setGameId('');
        setWatchGame(false)
        // setShowTournamentPlay(false);

        setBlackTime(data.moveTimer);
        setWhiteTime(data.moveTimer);
        setOpponentDisplayName(
          data.opponentusername == displayName
            ? data.username
            : data.opponentusername,
        );
        white = data.tossWinner;
        const black = data.userId == white ? data.opponentUserId : data.userId;

        setWhitePlayer(white); // white player
        setBlackPlayer(black);
        // setFirstMoveTimer(
        //   data?.data ==
        //     'rnbqkbnr/pppppppp/8/8/8/8/PPPPPPPP/RNBQKBNR w KQkq - 0 1'
        //     ? data.moveTimer - 20
        //     : data.moveTimer - 60,
        // );
        setMoves([]);
        movesSanRef.current = []; // broadcast-delta: reset full-list tracker on new game
        try { game?.load(data?.data); } catch (e) { console.warn('Invalid FEN skipped:', e?.message); }
        setPosition(data?.data);
        // setPosition(ChallengePosition ? ChallengePosition : "rnbqkbnr/pppppppp/8/8/8/8/PPPPPPPP/RNBQKBNR w KQkq - 0 1");
        let custom_rules_map = JSON.parse(data.customRulesMap);
        // setCustomRules(custom_rules_map.hasOwnProperty(username) ? custom_rules_map[username] : []);

        console.info(
          '... game ready response event .. ',
          JSON.stringify(data),
          socket.id,
        );
        // console.log('Setting up new FEN : ', data?.data);
        // game?.load(data?.data);
        // setPosition(game?.fen());

        setmyRating(
          data.opponentusername == displayName
            ? data.opponentRating
            : data.userRating,
        );
        setopponentRating(
          data.opponentusername == displayName
            ? data.userRating
            : data.opponentRating,
        );
        setStartfen(data.data);
        if (data.data.split(' ')[1] == 'b') {
          setIsBlackTurnFirst(true);
        } else {
          setIsBlackTurnFirst(false);
        }
        setTimeout(() => {
          setSearching(false);
          setStarted(true);
          setGameState(1);
          startGameStartCountdown();
          setChallengeInProgress(false);
        }, 1500);
        setWhiteWinRatio(0.5);
        setBlackWinRatio(0.5);
      }

      // function preStartGameResponseCallback(socket, data) {
      //   // already seated on new table
      //   setSearching(false);
      //   setGameStartTime(5000);
      //   setGameState(1);
      //   startGameStartCountdown();

      //   console.log('... game ready response event .. ', data);
      //   console.log('Setting up new FEN : ', data?.data);
      //   game?.load(data?.data);
      //   setWhitePlayer(data.white); // white player
      //   setBlackPlayer(data.black);

      //   setPosition(game?.fen());
      //   setBlackTime(data.timerValue);
      //   setWhiteTime(data.timerValue);
      // }

      function playerTurnResponseCallback(socket, data) {
        console.info(
          '... player turn event .. ',
          JSON.stringify(data),
          socket.id,
        );
        // Broadcast-delta: a live turn response carries only the new move; the
        // snapshot ('on connect' reconnect/fetch) carries the full list. Re-expand
        // a delta into the full moves[] so all downstream logic (prefix-append,
        // move_index, sounds, abort) works unchanged. Keeps movesSanRef in sync.
        if (Array.isArray(data.moves)) {
          if (data.requestId === 'on connect') {
            movesSanRef.current = data.moves.slice();
          } else {
            data.moves = [...movesSanRef.current, ...data.moves];
            movesSanRef.current = data.moves.slice();
          }
        }
        setFen(data?.data);
        fenRef.current = data?.data;
        setMyTurn(data.userId === username);

        if (data.userId === username) {
          setPreviousFen(data.previousFen);
          console.log('Setting up new FEN : ', data?.data);
          try { game?.load(data?.data); } catch (e) { console.warn('Invalid FEN skipped:', e?.message); }
          if (data.requestId == 'on connect') {
            setPosition(data?.previousFen);
            setTimeout(() => {
              setPosition(data?.data);
            }, 10);
          } else {
            setPosition(data?.data);
          }
          console.info('inside player turn response event handler 1');
          if (data.requestId !== 'on connect') {
            setTimeout(() => {
              setMoves(prevMoves => {
                const newMoves = data.moves.map(move => ({
                  move: move,
                  matched: false,
                  isHumanMove: false,
                }));
                // Monotonic merge: a delayed/stale response must not drop the
                // player's own (pre)move that a later response already appended.
                return mergeMoveList(prevMoves, newMoves);
              });
            }, 50);
          } else {
            getMoves(data.moves);
          }
        } else {
          if (data.requestId !== 'on connect') {
            setMoves(prevMoves => {
              const newMoves = data.moves.map(move => ({
                move: move,
                matched: false,
                isHumanMove: false,
              }));
              // Monotonic merge: keep our longer list if this response is a
              // stale/shorter-but-consistent prefix (premove-notation fix).
              return mergeMoveList(prevMoves, newMoves);
            });
          } else {
            getMoves(data.moves);
            setPreviousFen(data.previousFen);
            console.log('Setting up new FEN : ', data?.data);
            try { game?.load(data?.data); } catch (e) { console.warn('Invalid FEN skipped:', e?.message); }
            setPosition(data?.data);
          }
        }

        const move = data.moves[data.moves.length - 1];

        // if (move == lastMoveRef.current) {
        //   setLastMoveSent(true);
        //   console.info('last move played by user is', lastMoveRef.current);
        //   if (lastMovetimeoutRef.current) {
        //     clearTimeout(lastMovetimeoutRef.current);
        //     lastMovetimeoutRef.current = null; // Clear the reference
        //   }
        // } else {
        //   setLastMoveSent(false);
        // }

        // Determine the player color based on the move index
        const move_index = data.moves.length;
        const color = white === username ? 'white' : 'black';

        getAssistedGameMoveAnalysis(
          username,
          move,
          data?.data,
          color,
          data.previousFen,
          data.userId === username ? 'opponent' : 'me',
          tableid,
          move_index,
        );
        setMoveIndex(move_index);

        setBlackTime(data.blackTime);
        setWhiteTime(data.whiteTime);
        // setTimeout(() => {
        //     setMoves(data.moves);
        // }, (500));

        setWhitePiecesCaptured(
          data.whitePiecesCaptured.map(letter => letter.toUpperCase()),
        );
        setBlackPiecesCaptured(
          data.blackPiecesCaptured.map(letter => letter.toUpperCase()),
        );
        setShowAbort(
          data.moves.length > 1 ||
            (data.moves.length == 1 && !(data.userId === username))
            ? false
            : true,
        );
        console.info('inside player turn response event handler 2');
        if (data.moves.length == 1) {
          clearInterval(firstMovestartTimer);
          setFirstMoveStartTimer(null);
        }
        let my_time = username == white ? data.whiteTime : data.blackTime;
        if (
          data.moves.length > 10 &&
          my_time > total_time / 10 &&
          data.userId === username
        ) {
          SetThinkingTime(true);
          setTimeout(() => {
            SetThinkingTime(false);
          }, (total_time / 60) * 1000); // 5000 milliseconds = 5 seconds
        }

        setStarted(true);

        console.log('position is set :', position);
        console.log('New game FEN = ', game.fen());
      }

      // cc_client.registerMessageType('player_move', schema.moveResMsgSchema, function (socket, data) {
      //     console.log(' ... Player played move ... ', data);
      // });
      function registerPlayerMoveSchema(socket, data) {
        console.info(
          ' ... Player played move ... ',
          JSON.stringify(data),
          socket.id,
        );
      }

      function startGameCallback(socket, data) {
        console.info(' ... Start game notification ... ', JSON.stringify(data));
        setStarted(true);
        setPlaying(true);
        gameplayStore.setPlaying(true);
      }

      function drawCheckResponseCallback(socket, data) {
        console.info(
          '...DrawCheck message data...',
          JSON.stringify(data),
          socket.id,
        );
        if (data.userId == username && data.tableId == tableid) {
          setShowDrawRequest(true);
          recievedDrawSound();
        } // Show the draw request modal
      }

      function drawRejectedCallback(socket, data) {
        console.info(
          '...draw_reject message data...',
          JSON.stringify(data),
          socket.id,
        );
        if (data.tableId == tableid) {
          setDrawRequestSent(false);
          if (data.userId == username) {
            setShowDrawReject(true);
            rejectDrawSound();
            const timer = setTimeout(() => {
              setShowDrawReject(false);
            }, 2000);

            // Cleanup the timeout if the component unmounts or if drawRequestSent changes
            //   return () => clearTimeout(timer);
          }
        }
      }

      function challengeRequestCallback(socket, data) {
        console.info(
          '...challenge_request_check message data...',
          JSON.stringify(data),
        );
        navigation.navigate('PlayChess');
        if (data.userId == username) {
          setShowChallengeRequest(true && !cc_playing);
          setChallengeOpponent(data.opponent);
          setChallengeVariantId(data.variantId);
          setChallengeMoveTimer(data.playerMoveTimer);
          setChallengeIncrement(data.moveTimeIncrement);
          try {
            game?.load(
              data?.gameState ||
                'rnbqkbnr/pppppppp/8/8/8/8/PPPPPPPP/RNBQKBNR w KQkq - 0 1',
            );
          } catch (e) { console.warn('Invalid FEN skipped:', e?.message); }

          setPosition(
            data?.gameState ||
              'rnbqkbnr/pppppppp/8/8/8/8/PPPPPPPP/RNBQKBNR w KQkq - 0 1',
          );

          setChallengePosition(game?.fen());
          setChallengeWhite(data.white);
          // setBlackPlayer(data.black);
          setShowEndGameModal(false);
          setShowChallengeReject(false);
          setShowChallengeExpire(false);
          setShowChallengeCancel(false);
        } // Show the challenge request modal
      }

      function challengeRejectedCallback(socket, data) {
        console.info(
          '...challenge_reject message data...',
          JSON.stringify(data),
          socket.id,
        );
        setShowChallengeReject(true);
        gameplayStore?.setShowChallengeReject(true);
        setChallengeInProgress(false);
      }

      function challengeExpiredCallback(socket, data) {
        console.info(
          '...challenge_reject message data...',
          JSON.stringify(data),
          socket.id,
        );
        // Arena auto-pairing broadcasts CHALLENGE_REQUEST_EXPIRE to dismiss any
        // stale challenge modal after an accept — it is NOT a user-facing
        // expiry. Showing "The challenge has expired!" here pops a modal out of
        // nowhere between arena games, so suppress it in arena mode and just
        // clear the transient challenge state.
        if (isArenaRef.current) {
          setShowChallengeExpire(false);
          gameplayStore?.setShowChallengeExpire(false);
          setShowChallengeRequest(false);
          setChallengeInProgress(false);
          return;
        }
        // Dismiss-only here too: this screen's expired modal is dead code
        // (superseded by the app-wide ChallengeComponent) and
        // CHALLENGE_REQUEST_EXPIRE now also fires as an "accepted elsewhere"
        // dismiss signal, not just a genuine 20s timeout — never open it.
        setShowChallengeExpire(false);
        gameplayStore?.setShowChallengeExpire(false);
        setShowChallengeRequest(false);
        setChallengeInProgress(false);
      }

      // cc_client.registerMessageType('online_players_search', schema.onlinePlayersSearchMsgSchema, function (socket, data) {
      //     cc_client.username = username;
      // });

      function registerOnlinePlayersSearchSchema(socket, data) {
        cc_client.username = username;
      }

      function registerFetchGameStateSchema(socket, data) {
        cc_client.username = username;
      }

      function onlinePlayersSearchResult(socket, data) {
        console.info(
          '... online_players_result message data...',
          JSON.stringify(data),
          socket.id,
        );
        setSearchPlayersresult(data.players);
      }

      function tournamentOpeningPrepEvalPendingResponseCallback(socket, data) {
        console.info(
          '... tournament eval pending message data...',
          JSON.stringify(data),
          socket.id,
        );
        if (data.tableId == tableid) {
          setPlaying(false);
          gameplayStore.setPlaying(false);
          setStarted(true);
          setMyTurn(false);
          setShowDrawRequest(false);
          setDrawRequestSent(false);
          stopTimer();
          setShowEngineEvaluatingModal(true);
        }
      }

      const cclOpponentId = await getLocalStorage('league_opp_id');
      const leagueId = await getLocalStorage('league_id');

      function gameEndResponseCallback(socket, data) {
        console.info(
          ' ... end game response ... ',
          JSON.stringify(data),
          socket.id,
        );
        setStarted(true);
        console.info(
          'tableId set on client : ',
          tableid,
          cclOpponentId,
          data.endType,
          !!cclOpponentId && data.endType !== 'abort',
        );
        if (!!cclOpponentId && data.endType !== 'abort') {
          const payload = {
            league_id: leagueId,
            player_id: userId,
            opponent_id: cclOpponentId,
          };
          if (data.winner == username) {
            if (
              ['draw', 'stalemate', 'insufficient', 'repetition'].includes(
                data.endType,
              )
            ) {
              payload.result = 'draw';
            } else {
              payload.result = 'win';
            }
            payload.game_id = data.winner_gameId;
            payload.opp_game_id = data.opponent_gameId;
          } else {
            if (
              ['draw', 'stalemate', 'insufficient', 'repetition'].includes(
                data.endType,
              )
            ) {
              payload.result = 'draw';
            } else {
              payload.result = 'loss';
            }
            payload.opp_game_id = data.winner_gameId;
            payload.game_id = data.opponent_gameId;
          }
          console.log('create match payload', payload);
          createLeagueMatch(payload);
        }
        // The league challenge game has ended (win/loss/draw, or aborted with
        // no match recorded) — clear the keys so a subsequent ordinary game is
        // not mis-attributed as a league match.
        if (cclOpponentId) {
          clearLeagueChallengeKeys();
        }
        if (data.tableId == tableid || 1) {
          setShowEngineEvaluatingModal(false);
          try { game?.load(data?.gameState); } catch (e) { console.warn('Invalid FEN skipped:', e?.message); }
          setPosition(data?.gameState);
          setEndType(data.endType);
          console.info(' ... end game response ...  1');
          if (data.winner == username) {
            if (
              data.endType == 'draw' ||
              data.endType == 'stalemate' ||
              data.endType == 'insufficient' ||
              data.endType == 'repetition'
            ) {
              setResult('Draw');
              MatchEndedInDrawSound();
              setEndGameMessage('The match ended in a draw.');
            } else if (data.endType == 'abort') {
              setResult('Abort');
              setEndGameMessage('The match was aborted.');
              setmyRatingChange(0);
              setopponentRatingChange(0);
            } else {
              setResult('Win');
              winSound();
              setEndGameMessage('Congratulations! You won the match!');
              if (data.endType == 'timeup') {
                setopponentTime(0);
              }
            }
            setmyRating(data.winner_rating);
            setGameUuid(data.winner_gameId);
            setmyRatingChange(parseInt(data.winner_rating_delta));
            setopponentRating(data.opponent_rating);
            setopponentRatingChange(parseInt(data.opponent_rating_delta));
          } else if (
            data.endType == 'draw' ||
            data.endType == 'stalemate' ||
            data.endType == 'insufficient' ||
            data.endType == 'repetition'
          ) {
            setResult('Draw');
            setEndGameMessage('The match ended in a draw.');
            MatchEndedInDrawSound();
            setmyRating(data.opponent_rating);
            setmyRatingChange(parseInt(data.opponent_rating_delta));
            setGameUuid(data.opponent_gameId);
            setopponentRating(data.winner_rating);
            setopponentRatingChange(parseInt(data.opponent_rating_delta));
          } else if (data.endType == 'abort') {
            setResult('Abort');
            setEndGameMessage('The match was aborted.');
            setmyRatingChange(0);
            setopponentRatingChange(0);
          } else {
            setResult('Loss');
            lossSound();
            setEndGameMessage('Sorry, you lost the match.');
            if (data.endType == 'timeup') {
              setmyTime(0);
            }
            setmyRating(data.opponent_rating);
            setmyRatingChange(parseInt(data.opponent_rating_delta));
            setGameUuid(data.opponent_gameId);
            setopponentRating(data.winner_rating);
            setopponentRatingChange(parseInt(data.opponent_rating_delta));
          }
          console.info(' ... end game response ... 2');
          setPGN(data.pgn);
          setMoves(prevMoves => {
            const newMoves = data.moves.map(move => ({
              move: move,
              matched: false,
              isHumanMove: false,
            }));
            return mergeMoveList(prevMoves, newMoves);
          });
          console.info(' ... end game response ... 3');
          setWhitePiecesCaptured(
            data.whitePiecesCaptured.map(letter => letter.toUpperCase()),
          );
          setBlackPiecesCaptured(
            data.blackPiecesCaptured.map(letter => letter.toUpperCase()),
          );
          setChallengeMoveTimer(data.playerMoveTimer);
          setChallengeIncrement(data.moveTimeIncrement);
          setChallengeWhite(
            data.white == data.userId ? data.opponent : data.userId,
          );
          setMoveTimer(data.playerMoveTimer);
          setIncrement(data.moveTimeIncrement);
          setChallengeOpponent(
            data.opponent == username ? data.winner : data.opponent,
          );

          setPlaying(false);
          gameplayStore.setPlaying(false);
          cc_playing = false;
          setDrawRequestSent(false);
          setShowDrawRequest(false);
          // setMyTurn(false);
          if (data.endType == 'checkmate' || data.endType == 'stalemate') {
            setTimeout(() => {
              setShowEndGameModal(true);
            }, 1500);
          } else {
            setShowEndGameModal(true);
          }

          gameplayStore?.setShowEndGameModal(true);
          SetFoundOpponent(false);
          console.info(' ... end game response ... 4');
          if (isMobileOrTab) {
            setActiveTab('standings');
          }
          if (isArenaRef.current) {
            // Arena: return to the arena lobby view (in arena mode the
            // 'standings' tab renders ArenaLobby) and refresh my status —
            // the server re-pools both players and auto-pushes the next
            // start_game_response, which re-opens the board above.
            setActiveTab('standings');
            const arenaStore = useArenaStore.getState();
            arenaStore.resetGameBerserk();
            // Optimistic: myState 'paired' must not linger once the board is
            // gone (it would render "Game starting…" until the status reply
            // lands). The server re-pools us at scoring unless paused.
            arenaStore.setStatus({
              myState: arenaStore.status?.paused ? 'paused' : 'pooled',
            });
            sendArenaStatus();
          }

          setHint('');
          setHint2('');
          setIsBlackTurnFirst(false);
          console.log('reset restricted piece');
          setRestrictedPiece('');
        }
        // Reset all game flags
        // resetGameFlags();
      }
    }
  };

  const cancelJoinGameRequest = () => {
    // Cancelling join game request and unseating from table tableId

    // client.username = username;

    let packet = {};
    packet.requestId = new Date().getTime().toString();
    packet.type = 'leave_table_request';
    packet.tableId = tableId || 0;

    console.info(
      'Sending request to leave table .. ',
      JSON.stringify(packet),
      client.id,
    );

    // Send join game request
    client.send_msg('leave_table_request', packet);

    setSearching(false);
    setPosition('rnbqkbnr/pppppppp/8/8/8/8/PPPPPPPP/RNBQKBNR w KQkq - 0 1');
  };

  function joinGame(moveTimer, increment) {
    setSearching(true);
    setShowEndGameModal(false);
    setStarted(false);
    setChallengeInProgress(false);

    if (!client) {
      // something is wrong here
      window.alert('Refresh page to re-connect with server!');
      return;
    }

    // client.username = username;

    let packet = {};
    packet.requestId = new Date().getTime().toString();
    packet.type = 'join_game_request';
    packet.variantId = 1;
    packet.username = username;
    packet.message = '';
    packet.playerMoveTimer = moveTimer;
    packet.moveTimeIncrement = increment;
    packet.gamePlayMode = gamePlayMode;
    let timecontrol =
      (moveTimer / 1000).toString() + ' + ' + (increment / 1000).toString();
    setTimeControl(timecontrol);

    setMoveTimer(moveTimer);
    setIncrement(increment);

    setChallengeMoveTimer(moveTimer);
    setChallengeIncrement(increment);

    console.info(
      'Sending request to join game .. ',
      JSON.stringify(packet),
      client.id,
    );
    console.log('timeControl set to : ', timeControl);
    // Send join game request
    client.send_msg('join_game_request', packet);
  }

  function challengeGame(
    opponent,
    ChallengeMoveTimer,
    ChallengeIncrement,
    white = '',
    fen = 'rnbqkbnr/pppppppp/8/8/8/8/PPPPPPPP/RNBQKBNR w KQkq - 0 1',
  ) {
    if (!client) {
      // something is wrong here
      window.alert('Refresh page to re-connect with server!');
      return;
    }
    setShowEndGameModal(false);
    setStarted(false);
    // client.username = username;

    let packet = {};
    setChallengeOpponent(opponent + ':' + opponentDisplayName);
    packet.requestId = new Date().getTime().toString();
    packet.type = 'challenge_game_request';
    packet.variantId = 1;
    packet.userId = username;
    packet.opponent = opponent + ':' + opponentDisplayName;
    packet.playerMoveTimer = ChallengeMoveTimer;
    packet.moveTimeIncrement = ChallengeIncrement;
    packet.gameState = fen;
    packet.white = white;
    packet.black = '';
    packet.gamePlayMode = gamePlayMode;
    let timecontrol =
      (ChallengeMoveTimer / 1000).toString() +
      ' + ' +
      (ChallengeIncrement / 1000).toString();
    setTimeControl(timecontrol);
    console.info('Sending challenge game request  .. ', JSON.stringify(packet));
    setChallengeMoveTimer(ChallengeMoveTimer);
    setChallengeIncrement(ChallengeIncrement);

    // Send join game request
    client.send_msg('challenge_game_request', packet);
    console.log(ChallengeOpponent);

    setChallengeInProgress(true);
  }

  const isJoined = route.params?.isJoined;

  useEffect(() => {
    if ((isJoined === true || isJoined === 'true') && client) {
      joinTournament(tournamentId?.toString());
    }
  }, [isJoined, client]);

  function joinTournament(tournamentId) {
    let packet = {};
    packet.requestId = new Date().getTime().toString();
    packet.type = 'join_tournament_request';
    packet.playerId = username;
    packet.tournamentId = tournamentId;
    // client.username = username;
    console.info('sending join tournament request', JSON.stringify(packet));

    client.send_msg('join_tournament_request', packet);
  }

  // ── Arena send helpers ─────────────────────────────────────────────────
  // Same client + requestId convention as joinTournament. All arena_* types
  // ride the shared arenaEnvelopeSchema; arenaId = the current tournament id.
  // Uses the refs (not state) so the CCApplicationClient handler closures
  // (e.g. game-end auto-return) can call these without going stale.
  function sendArenaMessage(type, berserkTableId) {
    const c = clientRef.current;
    const arenaId = tournamentIdRef.current;
    if (!c || !arenaId || !schema.arenaEnvelopeSchema) {
      return;
    }
    const packet = {
      requestId: new Date().getTime().toString(),
      type: type,
      arenaId: arenaId.toString(),
      // top-level tableId is meaningful ONLY on arena_berserk_request (the
      // server shards its dispatch on it); empty string otherwise.
      tableId: berserkTableId != null ? berserkTableId.toString() : '',
      payload: '{}',
    };
    console.info('sending arena message', JSON.stringify(packet));
    c.send_msg(type, packet);
  }

  function sendArenaResume() {
    // doubles as "pool me" — sent on arena-lobby mount AND on Resume click
    sendArenaMessage('arena_resume_request');
  }

  function sendArenaPause() {
    sendArenaMessage('arena_pause_request');
  }

  function sendArenaStatus() {
    sendArenaMessage('arena_status_request');
  }

  function sendArenaBerserk(berserkTableId) {
    sendArenaMessage('arena_berserk_request', berserkTableId);
  }

  // Arena lobby mount / details-load: fetch my status ONLY. Fires once
  // TournamentPlay flips isArena after the details API identifies the
  // tournament as an arena (and again if the client or arena changes).
  // Deliberately NOT arena_resume — resuming here pooled every visitor and
  // silently UNPAUSED a paused player on refresh.
  useEffect(() => {
    if (isArena && client && tournamentId) {
      sendArenaStatus();
    }
  }, [isArena, client, tournamentId]);

  // Auto-resume (Lichess parity): a JOINED player who is idle while the
  // arena is running re-enters the pool automatically — but at most once per
  // tournament visit (arenaAutoResumedRef, reset on tournamentId change) so
  // this can't loop, and never for paused players (myState 'paused') or
  // spectators (!arenaIsJoined). Refresh therefore keeps paused players
  // paused.
  useEffect(() => {
    if (
      isArena &&
      client &&
      arenaIsJoined &&
      arenaStatus?.state === 'running' &&
      arenaStatus?.myState === 'idle' &&
      !arenaAutoResumedRef.current
    ) {
      arenaAutoResumedRef.current = true;
      sendArenaResume();
    }
  }, [isArena, client, arenaIsJoined, arenaStatus]);

  // Socket reconnect while inside an arena — server state may have moved
  // (game ended / arena finished) while we were away, so refetch status.
  useEffect(() => {
    if (isConnected && isArenaRef.current) {
      sendArenaStatus();
    }
  }, [isConnected]);

  function withDrawPlayer(username, tournamentId, round) {
    let packet = {};
    packet.requestId = new Date().getTime().toString();
    packet.type = 'withdraw_tournament_request';
    packet.playerId = username;
    packet.tournamentId = tournamentId.toString();
    packet.round = round;
    // client.username = username;

    console.info('sending withdraw player request', JSON.stringify(packet));
    client.send_msg('withdraw_tournament_request', packet);
  }

  function watchTournamentGame(pairingKey, tournamentId, round) {
    // Stop watching the current game before switching, so the server stops
    // pushing the old game's turn/end events — otherwise stale events from the
    // previous game corrupt the newly-watched board. Local watch state is left
    // alone; the new watch response overwrites it without a flicker.
    if (watchTableId) {
      client?.send_msg('stop_watching_tournament_game_request', {
        requestId: new Date().getTime().toString(),
        type: 'stop_watching_tournament_game_request',
        userId: username,
        tableId: watchTableId,
      });
    }
    let packet = {};
    packet.requestId = new Date().getTime().toString();
    packet.type = 'watch_tournament_game_request';
    packet.userId = username;
    packet.pairingKey = pairingKey;
    packet.tournamentId = tournamentId.toString();
    packet.round = round;
    // client.username = username;
    console.info(
      'sending watch tournament game request',
      JSON.stringify(packet),
      round,
    );

    client?.send_msg('watch_tournament_game_request', packet);
  }

  // Open a FINISHED arena game on the board by tableId (redis-first, robust).
  // Mirrors the Swiss "recent → redis, aged → DB" flow: redis moves survive
  // finish (7-day TTL), so /arenaGameReplay serves a full snapshot we render
  // through the SAME watch* state the live spectate path uses — but WITHOUT a
  // socket watch room (it's a static replay of a done game). If the table has
  // aged out of redis (found:false), fall back to the DB-uuid replay
  // (setGameId → game/get_games) — the prod path once Django's async save has
  // landed. Redis presence IS the gate; no brittle date check.
  async function openArenaGameByTable(tableId, fallbackUuid) {
    let data = null;
    try {
      data = await fetchArenaGameReplay(tableId);
    } catch (e) {
      console.warn('arenaGameReplay fetch failed:', e?.message);
    }
    if (data && data.found) {
      setWatchGame(true);
      setActiveTab('notation');
      setStartFenTournament(data.startFen);
      setWatchGameState(data.gameState);
      setWatchState(data.state);
      setTournamentMoves(
        (data.moves || []).map(move =>
          move && typeof move === 'object'
            ? {...move, matched: false, isHumanMove: false}
            : {move, matched: false, isHumanMove: false},
        ),
      );
      // broadcast-delta: seed the watch tracker with this full snapshot.
      watchMovesSanRef.current = (data.moves || []).map(m =>
        m && typeof m === 'object' ? m.move : m,
      );
      setWatchPrevGameState(data.prevGameState || '');
      setWatchWhite(data.white);
      setWatchBlack(data.black);
      setWatchWhiteUsername(data.whiteUsername);
      setWatchBlackUsername(data.blackUsername);
      setWatchWhiteRating(data.whiteRating);
      setWatchBlackRating(data.blackRating);
      setWatchWhiteTime(Math.round((data.whiteTime || 0) / 1000));
      setWatchBlackTime(Math.round((data.blackTime || 0) / 1000));
      setWatchPlayerMoveTimer(data.playerMoveTimer);
      setWatchMoveTimeIncrement(data.moveTimeIncrement);
      setWatchTableId(data.tableId);
      setWatchCurrentPlayer(data.currentPlayer);
      setWatchWhitePiecesCaptured(
        (data.whitePiecesCaptured || []).map(letter => letter.toUpperCase()),
      );
      setWatchBlackPiecesCaptured(
        (data.blackPiecesCaptured || []).map(letter => letter.toUpperCase()),
      );
      setIllegalTouchPieceCount(prevCount => prevCount + 1);
      return;
    }
    // aged out of redis → DB-uuid replay. Mirror the Swiss DB-open (games.tsx):
    // setGameId + switch to the notation tab so the replayed board is actually
    // shown — the [gameId] effect otherwise lands on 'details' and the board is
    // never visible. Synthetic bypass uuids won't resolve locally, but this is
    // the durable prod path.
    if (fallbackUuid) {
      setGameId(fallbackUuid);
      setActiveTab('notation');
    } else {
      console.warn(
        'openArenaGameByTable: game aged out of redis and has no fallback uuid — cannot replay',
      );
    }
  }

  function getTournamentStatus(tournamentId) {
    let packet = {};
    packet.requestId = new Date().getTime().toString();
    packet.type = 'get_tournament_status';
    packet.tournamentId = tournamentId.toString();

    console.info(
      'sending get tournament status request',
      JSON.stringify(packet),
    );

    client?.send_msg('get_tournament_status', packet);
  }

  function stopWatchingTournamentGame(tableId) {
    let packet = {};
    packet.requestId = new Date().getTime().toString();
    packet.type = 'stop_watching_tournament_game_request';
    packet.userId = username;
    packet.tableId = tableId;
    // client.username = username;
    console.info(
      'sending stop watching tournament game request',
      JSON.stringify(packet),
    );

    client.send_msg('stop_watching_tournament_game_request', packet);
    setWatchTableId(0);
    if (watchGame) {
      setWatchGame(false);
    }
  }

  function drawRequest() {
    if (!client) {
      // something is wrong here
      window.alert('Refresh page to re-connect with server!');
      return;
    }

    // client.username = username;

    let packet = {};
    // setCntr(cntr + 1);
    packet.requestId = new Date().getTime().toString();
    packet.username = username;
    packet.type = 'draw_request';
    packet.tableId = tableId;
    packet.move = 'draw';

    console.info('draw request Packet = ', JSON.stringify(packet), client.id);

    // Send join game request
    client.send_msg('player_move', packet);

    setDrawRequestSent(true);
  }

  function resign() {
    if (!client) {
      // something is wrong here
      window.alert('Refresh page to re-connect with server!');
      return;
    }

    // client.username = username;

    let packet = {};
    // setCntr(cntr + 1);
    packet.requestId = new Date().getTime().toString();
    packet.username = username;
    packet.type = 'player_resign';
    packet.tableId = tableId;
    packet.move = 'resign';

    console.info('Resign Packet = ', JSON.stringify(packet), client.id);

    // Send join game request
    client.send_msg('player_move', packet);
  }

  function searchPlayers(pattern) {
    if (!client) {
      // something is wrong here
      window.alert('Refresh page to re-connect with server!');
      return;
    }

    let packet = {};
    packet.requestId = new Date().getTime().toString();
    packet.userId = username;
    packet.type = 'online_players_search';
    packet.pattern = pattern;

    console.info(
      'searching players by username Packet = ',
      JSON.stringify(packet),
      client.id,
    );
    setSearchPlayersresult('');
    setOpponentDisplayName('');

    client.send_msg('online_players_search', packet);
  }

  function abort() {
    if (!client) {
      // something is wrong here
      window.alert('Refresh page to re-connect with server!');
      return;
    }

    // client.username = username;
    console.log('inside abort');
    let packet = {};
    // setCntr(cntr + 1);
    packet.requestId = new Date().getTime().toString();
    packet.username = username;
    packet.type = 'game_abort';
    packet.tableId = tableId;
    packet.move = 'abort';

    console.info('Abort Packet = ', JSON.stringify(packet), client.id);

    // Send join game request
    client.send_msg('player_move', packet);
  }

  const makeMove = (s, d, p) => {
    const pieceAtSquare = game.get(s);

    if (myTurn) {
      game?.move({
        from: s,
        to: d,
        promotion: p,
      });

      const move = game.history().slice(-1)[0];

      let packet = {};
      packet.requestId = new Date().getTime().toString();
      packet.username = username;
      packet.type = 'player_move';
      packet.tableId = tableId;
      packet.move = move;

      console.info('Move Packet = ', JSON.stringify(packet), client.id);

      if (showDrawRequest) {
        // A move was made while the player was offered a draw request
        // The user ignored the draw request, so we send back an implicit decline
        console.info('inside draw reject with move....');
        handleDrawResponse(false);
        setShowDrawRequest(false);
      }

      setLastMove(move);
      client.send_msg('player_move', packet);

      // retry move if player turn response doesn't acknowledge it
      // const timeoutId = setTimeout(() => {
      //   if (!lastMoveSent) {
      //     // client.send_msg('player_move', packet);
      //     const timeoutId_2 = setTimeout(() => {
      //       if (!lastMoveSent) {
      //         CCApplicationClient();
      //       }
      //     }, 1000);
      //     lastMovetimeoutRef.current = timeoutId_2;
      //   }
      // }, 500);
      // lastMovetimeoutRef.current = timeoutId;
    } else if (pieceAtSquare && isPieceMine(pieceAtSquare.color)) {
      return false;
    } else {
      return true;
    }
  };

  const handleDrawResponse = accepted => {
    let packet = {};
    packet.requestId = new Date().getTime().toString();
    packet.username = username;
    packet.type = 'draw_response';
    packet.tableId = tableId;
    if (accepted) {
      packet.move = 'Y';
    } else {
      packet.move = 'N';
    }
    console.info('draw response Packet = ', JSON.stringify(packet), client.id);
    client.send_msg('player_move', packet);

    setShowDrawRequest(false); // Close the draw request modal
  };

  const handleChallengeResponse = accepted => {
    let packet = {};
    packet.requestId = new Date().getTime().toString();
    packet.variantId = ChallengeVariantId;
    packet.userId = username;
    packet.opponent = ChallengeOpponent;
    packet.playerMoveTimer = ChallengeMoveTimer;
    packet.moveTimeIncrement = ChallengeIncrement;
    packet.gameState = ChallengePosition;
    packet.white = ChallengeWhite;
    packet.black = blackPlayer;
    packet.gamePlayMode = gamePlayMode;

    packet.tableId = tableId;
    if (accepted) {
      let timecontrol =
        (ChallengeMoveTimer / 1000).toString() +
        ' + ' +
        (ChallengeIncrement / 1000).toString();
      setTimeControl(timecontrol);
      packet.type = 'challenge_accept_response';
    } else {
      packet.type = 'challenge_reject';
      // setChallengeOpponent('');
      // setChallengeVariantId('');
      // setChallengeMoveTimer('');
      // setChallengeIncrement('');
    }
    console.info('Packet = ', JSON.stringify(packet));
    client.send_msg('challenge_game_request', packet);

    setShowChallengeRequest(false); // Close the Challenge request modal
  };

  const handleChallengeCancel = () => {
    let packet = {};
    packet.requestId = new Date().getTime().toString();
    packet.variantId = ChallengeVariantId || 0;
    packet.userId = String(username || '');
    packet.opponent = String(ChallengeOpponent || '');
    packet.playerMoveTimer = ChallengeMoveTimer || 0;
    packet.moveTimeIncrement = ChallengeIncrement || 0;
    packet.gameState = String(ChallengePosition || '');
    packet.white = String(ChallengeWhite || '');
    packet.black = String(blackPlayer || '');
    packet.gamePlayMode = String(gamePlayMode || '');

    // packet.tableId = tableId;
    packet.type = 'challenge_cancel';
    console.info(
      'challenge cancel Packet = ',
      JSON.stringify(packet),
      client.id,
    );
    client.send_msg('challenge_game_request', packet);
    setChallengeInProgress(false);
    setPosition('rnbqkbnr/pppppppp/8/8/8/8/PPPPPPPP/RNBQKBNR w KQkq - 0 1');
  };

  const handle_end_game_modal = () => {
    setShowEndGameModal(false);
    setShowEngineEvaluatingModal(false);
    stopTimer();
    //setPosition('rnbqkbnr/pppppppp/8/8/8/8/PPPPPPPP/RNBQKBNR w KQkq - 0 1');
    //setmyTime(600);
    //setopponentTime(600);
    // setTimeControl('');
    // setStarted(false);
    setSearching(false);
    setChallengeInProgress(false);
    setChallengePosition(
      'rnbqkbnr/pppppppp/8/8/8/8/PPPPPPPP/RNBQKBNR w KQkq - 0 1',
    );
    setShowAssitedGameplay(false);
    if (isMobileOrTab) {
      setStarted(false);
    }
    if (watchGame) {
      setWatchGame(false);
      setActiveTab('games');
    }

    // Additional logic to handle modal close if needed
  };

  const handle_challenge_reject = () => {
    setChallengeInProgress(false);

    setShowChallengeReject(false);
    setShowChallengeCancel(false);
    // setChallengeOpponent('');
    // setChallengeVariantId('');
    // setChallengeMoveTimer('');
    // setChallengeIncrement('');
    // setTimeControl('');
    gameplayStore.setShowChallengeCancel(false);
    gameplayStore.setShowChallengeExpire(false);
    gameplayStore.setShowChallengeReject(false);
    setChallengeInProgress(false);
    setShowChallengeExpire(false);
    setShowPlayerNotFound(false);
    setShowTnrStarting(false);
    setPosition('rnbqkbnr/pppppppp/8/8/8/8/PPPPPPPP/RNBQKBNR w KQkq - 0 1');
    setChallengePosition(
      'rnbqkbnr/pppppppp/8/8/8/8/PPPPPPPP/RNBQKBNR w KQkq - 0 1',
    );
  };

  const handle_new_game = () => {
    setStarted(false);
    setPosition('rnbqkbnr/pppppppp/8/8/8/8/PPPPPPPP/RNBQKBNR w KQkq - 0 1');
    setShowAssitedGameplay(false);
    setGamePlayMode('Play');
    setAssistedGameplay(false);
  };

  const onGameStart = () => {};

  // Startup script: connect with server and keep the connection intact at startup
  useEffect(() => {
    CCApplicationClient();
    setWhitePlayer(username);
  }, [username, accessToken, socket]);

  useEffect(() => {
    const setLeagueData = async () => {
      const league_opp_id = await getLocalStorage('league_opp_id');
      if (league_opp_id && !!client) {
        searchPlayers('');
      }
    };
    setLeagueData();
  }, [client]);

  useEffect(() => {
    console.log('New Client set to = ', client);
    const joinChallenge = async () => {
      console.log('Joining Challenge from non-gameplay screen ....');
      const challengePacket = await getLocalStorage('challengePacket');
      // console.log(
      //   'Challenge Packet retrieved from LocalStorage = ',
      //   challengePacket,
      // );

      if (challengePacket) {
        setShowChallengeRequest(false);
        setChallengeOpponent(challengePacket.opponent);
        setChallengeVariantId(challengePacket.variantId);
        setChallengeMoveTimer(challengePacket.playerMoveTimer);
        setChallengeIncrement(challengePacket.moveTimeIncrement);
        try {
          game?.load(
            challengePacket?.gameState ||
              'rnbqkbnr/pppppppp/8/8/8/8/PPPPPPPP/RNBQKBNR w KQkq - 0 1',
          );
        } catch (e) { console.warn('Invalid FEN skipped:', e?.message); }
        if (
          game?.fen() !=
          'rnbqkbnr/pppppppp/8/8/8/8/PPPPPPPP/RNBQKBNR w KQkq - 0 1'
        ) {
          setPosition(challengePacket?.gameState);
        }
        setChallengePosition(challengePacket?.gameState);
        setChallengeWhite(challengePacket.white);
        // setBlackPlayer(data.black);
      }

      setLocalStorage('challengePacket', null);

      // if (client && challengePacket) {
      //   let timecontrol =
      //     (challengePacket.playerMoveTimer / 1000).toString() +
      //     ' + ' +
      //     (challengePacket.moveTimeIncrement / 1000).toString();
      //   setTimeControl(timecontrol);
      //   setTimeout(() => {
      //     client.send_msg('challenge_game_request', challengePacket);
      //   },1500);

      // }
    };

    joinChallenge();
    setShowEndGameModal(false);
    setShowChallengeReject(false);
    setShowChallengeExpire(false);
    setShowChallengeCancel(false);

    if (client && username) {
      client.username = username;
      let packet = {};
      packet.requestId = new Date().getTime().toString();
      packet.type = 'fetch_game_state';
      packet.userId = username;

      console.info(
        'fetch game state packet is :',
        JSON.stringify(packet),
        client.id,
      );

      client.send_msg('fetch_game_state', packet);
      gameplayStore.setTournamentPlay(false);
    }
  }, [client]);

  useEffect(() => {
    console.info('myTurn set to ', myTurn);
    const premoves = chessboardRef?.current?.premoves;
    console.log('Current premoves:', premoves);
    if (whitePlayer == username) {
      setmyTime(whiteTime);
      setopponentTime(blackTime);
    } else {
      setmyTime(blackTime);
      setopponentTime(whiteTime);
    }
    if (!myTurn) {
      console.log('reset restricted piece');
      setRestrictedPiece('');
      // firstMoveCountdown();
    }
    myTurnRef.current = myTurn;
  }, [myTurn, whiteTime, blackTime]);

  useEffect(() => {
    if (showEndGameModal && !watchGame) {
      stopTimer();
      console.log('saving circlechess game : ', pgn);
      // let opponentUserId = (
      //   whitePlayer == username ? blackPlayer : whitePlayer
      // ).toString();
      // const now = new Date();
      // const year = now.getFullYear();
      // const month = String(now.getMonth() + 1).padStart(2, '0');
      // const day = String(now.getDate()).padStart(2, '0');
      // const hours = String(now.getHours()).padStart(2, '0');
      // const minutes = String(now.getMinutes()).padStart(2, '0');
      // const seconds = String(now.getSeconds()).padStart(2, '0');

      // let headers = `[Variant "Standard"]\n[TimeControl "${timeControl}"]\n\n`;
      // if (
      //   startfen !== 'rnbqkbnr/pppppppp/8/8/8/8/PPPPPPPP/RNBQKBNR w KQkq - 0 1'
      // ) {
      //   headers = `[Variant "From Position"]\n[TimeControl "${timeControl}"]\n[FEN "${startfen}"]\n\n`;
      // }
      handleClearPremoves();

      let packet = {};
      packet.requestId = new Date().getTime().toString();
      packet.userId = username;
      packet.type = 'end_game_confirmed';

      console.info(
        'end_game_confirmed packet is :',
        JSON.stringify(packet),
        client.id,
      );

      client.send_msg('end_game_confirmed', packet);

      // const endTime = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
      // let pgnContent = headers + pgn;
      // let userId = username;
      // let color = whitePlayer == username ? 'White' : 'Black';
      // console.log('pgn is : ', pgnContent);
      // setChallengeOpponent(opponentUserId);
      // if (Result !== 'Abort') {
      //   saveCirclechessGame({
      //     userId,
      //     pgnContent,
      //     opponentUserId,
      //     color,
      //     endTime,
      //     Result,
      //     timeControl,
      //     opponentUsername: opponentDisplayName,
      //     myRating,
      //     opponentRating,
      //     endType,
      //   });
      // }
    }
  }, [showEndGameModal]);

  useEffect(() => {
    console.log(
      'save circle chess data ',
      JSON.stringify(saveCirclechessGameData),
    );
    if (saveCirclechessGameData && saveCirclechessGameData.game_uuid) {
      setGameUuid(saveCirclechessGameData.game_uuid);
      console.log('game_uuid is : ', saveCirclechessGameData.game_uuid);
    }
  }, [saveCirclechessGameData]);
  useEffect(() => {
    console.log(
      'CheckCircleChessGamesAnalyzedRule data ',
      JSON.stringify(CheckCircleChessGamesAnalyzedRuleData),
    );
    if (CheckCircleChessGamesAnalyzedRuleData) {
      setShowReviewGamesComponent(
        !CheckCircleChessGamesAnalyzedRuleData.success,
      );
    }
  }, [CheckCircleChessGamesAnalyzedRuleData]);

  useEffect(() => {
    console.log('GetGameWithTagData data ', JSON.stringify(GetGameWithTagData));
    if (GetGameWithTagData && GetGameWithTagData.fen) {
      setGameWithTagFen(GetGameWithTagData.fen);
      console.log('fen is : ', GetGameWithTagData.fen);
    }
  }, [GetGameWithTagData]);

  const isValidPreMove = (game, from, to) => {
    const allMoves = game.moves({verbose: true});
    return allMoves.some(move => move.from === from && move.to === to);
  };

  // useEffect(() => {
  //     if (playing && myTurn) {
  //         stopTimer()
  //         startmyTimer(); // Start the timer when the game starts
  //         // if(preMove){
  //         //     const { from, to, promotion } = preMove;
  //         //     if (isValidPreMove(game, from, to)) {
  //         //         game?.move({ from, to, promotion });

  //         //         const move = game.history().slice(-1)[0];

  //         //         let packet = {};
  //         //         packet.requestId = new Date().getTime().toString();
  //         //         packet.username = username;
  //         //         packet.type = 'player_move';
  //         //         packet.tableId = tableId;
  //         //         packet.move = move;

  //         //         console.log('Packet = ', packet);

  //         //         client.send_msg('player_move', packet);
  //         //         setPreviousFen(position);
  //         //         setPosition(game?.fen());
  //         //         setPreMove(null);
  //         //     } else {
  //         //         console.log('Invalid pre-move:', preMove);
  //         //         setPreMove(null); // Clear the invalid pre-move
  //         //     }
  //         // }

  //     } else if (playing && !myTurn) {
  //         stopTimer();
  //         startopponentTimer();
  //     }
  //     else {
  //         stopTimer();
  //     }
  //     return () => {
  //         stopTimer(); // Clean up: stop the timer when the component unmounts
  //     };

  // }, [playing, myTurn]);

  const handleChallenge = () => {
    if (ChallengeOpponent.trim() !== '' && ChallengeMoveTimer.trim !== '') {
      challengeGame(ChallengeOpponent, ChallengeMoveTimer, ChallengeIncrement);
    } else {
      // Handle case when opponent's username is empty
      alert(
        "Please enter opponent's username and Time Control for the challenge",
      );
    }
  };
  const {
    mutate: feedBack,
    data: userData,
    isLoading: userLoading,
    error: userError,
  } = useAssistedPuzzleFeedback();

  async function handleSubmit(selectedFeedback) {
    try {
      await feedBack({
        feedback: selectedFeedback,
        uuid: uuid,
        userid: userId,
        move_index: moveIndex,
      });
    } catch (error) {
      console.error(error);
    }
  }

  useEffect(() => {
    if (searching) {
      const timer = setTimeout(() => {
        console.info('join game request expired .... ');
        cancelJoinGameRequest();
        setShowPlayerNotFound(true);
      }, 15000); // 20000 milliseconds = 20 seconds

      // Cleanup the timer if the component unmounts or if `searching` changes
      return () => clearTimeout(timer);
    }
  }, [searching, tableId]);

  const [showNotification, setShowNotification] = useState(false);

  useEffect(() => {
    let timeout;
    if (!isConnected) {
      timeout = setTimeout(() => {
        setShowNotification(true);
      }, 1000);
    } else {
      setShowNotification(false);
      if (timeout) {
        clearTimeout(timeout);
      }
    }

    return () => {
      if (timeout) {
        clearTimeout(timeout);
      }
    };
  }, [isConnected]);

  function isPieceMine(pieceColor) {
    // Check if the username matches the player assigned to the color of the restricted piece
    if (pieceColor === 'w' && whitePlayer === username) {
      return true; // The restricted piece belongs to the current user (White player)
    }
    if (pieceColor === 'b' && blackPlayer === username) {
      return true; // The restricted piece belongs to the current user (Black player)
    }
    return false; // The restricted piece does not belong to the current user
  }

  function canMoveRestrictedPiece(square) {
    console.log('Piece can be moved or not check');
    // Generate all legal moves for the color
    const legalMoves = game.moves({square, verbose: true});

    // Check if there are any legal moves for the piece
    if (legalMoves.length > 0) {
      // The piece can be moved legally
      console.log(`Piece on ${square} can be moved.`);
      return true;
    } else {
      // No legal moves, so increment the illegal touch piece count
      console.log(`Piece on ${square} cannot be moved.`);
      // setIllegalTouchPieceCount(prevCount => prevCount + 1);
      return false;
    }
  }

  const onPieceDragBegin = (piece, square) => {
    console.log('Piece drag begin', piece[1], square);
    if (
      customRules.includes('touch_piece_rule') &&
      canMoveRestrictedPiece(square)
    ) {
      setRestrictedPiece({
        type: piece[1].toLowerCase(),
        square: square,
        color: piece[0],
      });
    }
  };

  useEffect(() => {
    console.log(
      'change in restricted piece: ',
      JSON.stringify(restrictedPiece),
    );
    restrictedPieceRef.current = restrictedPiece;
    if (customRules.includes('touch_piece_rule')) {
      let packet = {};
      packet.requestId = new Date().getTime().toString();
      packet.username = username;
      packet.type = 'touch_piece';
      packet.tableId = tableId;
      packet.move = JSON.stringify(restrictedPiece);

      console.info('touch piece Packet = ', JSON.stringify(packet));
      client?.send_msg('player_move', packet);
    }
  }, [restrictedPiece]);

  useEffect(() => {
    if (moveClicked) {
      fenRef.current = position;
    }
  }, [position, moveClicked]);

  const restrictPiece = (piece, square) => {
    let boardOrientation = whitePlayer == username ? 'w' : 'b';
    console.log('Piece Clicked', piece, square);
    if (game?.fen().toString() != fenRef.current) {
      // setPosition(game?.fen().toString());
      setIllegalTouchPieceCount(prevCount => prevCount + 1);
    }
    if (piece) {
      piece.square = square;
    }
    if (
      !restrictedPieceRef.current &&
      customRules.includes('touch_piece_rule') &&
      canMoveRestrictedPiece(square) &&
      piece.color === boardOrientation
    ) {
      setRestrictedPiece(piece);
    }
  };

  const handleContinue = () => {
    gameplayStore.setShowChangeInClient(false);
    setChangeClient(false);
    reconnectSocket();
  };

  const handleClose = () => {
    // gameplayStore.setShowChangeInClient(false);
    navigation.navigate('Dashboard');
    // Logic to close this window or session
  };

  const handleStockfishResult = (
    variationNumber,
    moves,
    baseTurnTemp,
    extractedScore,
  ) => {
    console.log('stockfish score :', extractedScore);
    const {whiteWinRatio, blackWinRatio} = calculateWinRatios(extractedScore);
    console.log('whiteWinRatio is : ', whiteWinRatio);
    if (myTurnRef.current) {
      setWhiteWinRatio(blackWinRatio);
      setBlackWinRatio(whiteWinRatio);
    } else {
      setWhiteWinRatio(whiteWinRatio);
      setBlackWinRatio(blackWinRatio);
    }
  };
  const [chessboardSize, setChessboardSize] = useState(0);

  const onParentLayout = event => {
    const {width, height} = event.nativeEvent.layout;
    // Calculate the size based on the smaller of the parent's width and height
    const size = Math.min(width, height);
    const tournamentPlaysize = height / 9;
    setChessboardSize(size - tournamentPlaysize);
  };

  useEffect(() => {
    if (!watchGame && watchTableId) {
      stopWatchingTournamentGame(watchTableId);
    }
  }, [watchGame]);

  useEffect(() => {
    if (watchGame) {
      setWatchGameState(position);
      setWatchPrevGameState(previousFen);
    }
  }, [position, previousFen]);

  const [gameId, setGameId] = useState('');
  const [opponentTimeTournament, setOpponentTimeTournament] = useState(600);
  const [myTimeTournament, setMyTimeTournament] = useState(600);
  const [usernameTournament, setUsernameTournament] = useState(username);
  const [displayNameTournament, setDisplayNameTournament] =
    useState(displayName);
  const [opponentTournament, setOpponentTournament] = useState('opponent');
  const [whiteTournament, setWhiteTournament] = useState(username);
  const [myRatingTournament, setMyRatingTournament] = useState(myRating);
  const [opponentRatingTournament, setOpponentRatingTournament] = useState(0);
  const [tournamentMoves, setTournamentMoves] = useState([]);
  const [startfenTournament, setStartFenTournament] = useState('');

  const {mutate: fetchGames, data} = useGetUserGamesApi();
  useEffect(() => {
    if (gameId && gameId !== 'stop_watching') {
      setStarted(false);
      fetchGames({page: 1, game_id: gameId});
    }
    if (!gameId) {
      // setOpponentTimeTournament();
      // setMyTimeTournament();
      setUsernameTournament(username);
      setDisplayNameTournament(displayName);
      setOpponentTournament('opponent');
      setWhiteTournament(username);
      setStartFenTournament('');
      setMyRatingTournament(myRating);
      setOpponentRatingTournament(0);
      setWhitePlayer(username);
      setTournamentMoves([]);
      watchMovesSanRef.current = []; // broadcast-delta: reset watch tracker
      setPosition('rnbqkbnr/pppppppp/8/8/8/8/PPPPPPPP/RNBQKBNR w KQkq - 0 1');
      setStarted(false);
    }
    if (gameId == 'stop_watching') {
      if (client && watchTableId) {
        setActiveTab('games');
        stopWatchingTournamentGame(watchTableId);
      } else {
        setGameId('');
        setActiveTab('games');
      }
    } else {
      setActiveTab('details');
    }
  }, [gameId]);

  useEffect(() => {
    if (data) {
      console.log('game fetched by game id, data:', data);
      setWhitePlayer(
        data?.data?.data.username == displayName ||
          data?.data?.data.opponent_username == displayName
          ? (data?.data?.data?.userid == username &&
              data?.data?.data?.color == 'White') ||
            (data.data.data.userid != username &&
              data.data.data.color == 'Black')
            ? username
            : data?.data?.data?.opponent_username
          : data?.data?.data?.color == 'White'
          ? username
          : '',
      );
      const myGame =
        data?.data?.data.username == displayName ||
        data?.data?.data.opponent_username == displayName;
      setPosition(data?.data?.data?.start_fen);
      setOpponentTimeTournament(
        myGame
          ? data.data.data.userid == username
            ? data.data.data.opponent_time_left_on_clock
            : data.data.data.time_left_on_clock
          : data.data.data.opponent_time_left_on_clock,
      );

      setMyTimeTournament(
        myGame
          ? data.data.data.userid == username
            ? data.data.data.time_left_on_clock
            : data.data.data.opponent_time_left_on_clock
          : data.data.data.time_left_on_clock,
      );
      setStartFenTournament(data.data.data.start_fen);

      setUsernameTournament(myGame ? username : data.data.data.userid);

      setDisplayNameTournament(
        myGame
          ? data.data.data.userid == username
            ? data.data.data.username
            : data.data.data.opponent_username
          : data.data.data.username,
      );

      setOpponentTournament(
        myGame
          ? data.data.data.userid == username
            ? data.data.data.opponent_username
            : data.data.data.username
          : data.data.data.opponent_username,
      );

      setWhiteTournament(
        myGame
          ? (data.data.data.userid == username &&
              data.data.data.color == 'White') ||
            (data.data.data.userid != username &&
              data.data.data.color == 'Black')
            ? username
            : data.data.data.opponent_username
          : data.data.data.color == 'White'
          ? data.data.data.userid
          : data.data.data.opponent_username,
      );

      setMyRatingTournament(
        myGame
          ? data.data.data.userid == username
            ? data.data.data.rating
            : data.data.data.opponent_rating
          : data.data.data.rating,
      );

      setOpponentRatingTournament(
        myGame
          ? data.data.data.userid == username
            ? data.data.data.opponent_rating
            : data.data.data.rating
          : data.data.data.opponent_rating,
      );
      setTournamentMoves(
        data?.data?.move_list.map(move => ({
          move: move,
          matched: false,
          isHumanMove: false,
        })),
      );
      // broadcast-delta: full move_list snapshot from API — seed the watch tracker.
      watchMovesSanRef.current = (data?.data?.move_list || []).slice();
      setTimeout(() => {
        setIllegalTouchPieceCount(prevCount => prevCount + 1);
      }, 100);
    }
  }, [data]);

  // Captured pieces, computed ONCE per board change instead of inline at each of
  // the ~14 render call sites. Pre-uppercased to match the old per-site .map().
  // Player tray sources from game.fen() — the chess.js board is updated
  // synchronously in makeMove (game.move()) — NOT from `position`, which we
  // deliberately do NOT setPosition on the player's own move (the chessboard
  // animates it locally), so `position` stays stale until the opponent replies.
  // Falls back to position/fen if game isn't ready. Recompute deps cover both
  // sides: own move bumps lastMove; opponent move bumps position/fen/moveIndex.
  const playerCapturedPieces = useMemo(() => {
    const c = getCapturedPieces(game?.fen?.() || position || fen || '');
    return {
      w: c.w.map(l => l.toUpperCase()),
      b: c.b.map(l => l.toUpperCase()),
    };
    // game is a mutated-in-place Chess instance (stable ref), so it can't be a
    // dep; the state deps below change on every board update.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [position, fen, lastMove, moveIndex]);

  // Spectator tray: watchGameState is the authoritative watched-board FEN.
  const watchCapturedPieces = useMemo(() => {
    const c = getCapturedPieces(watchGameState || '');
    return {
      w: c.w.map(l => l.toUpperCase()),
      b: c.b.map(l => l.toUpperCase()),
    };
  }, [watchGameState]);

  function getTournamentDetails(tournamentId) {
    setTournamentId(tournamentId);
    setShowTournamentPlay(true);
    gameplayStore.setTournamentPlay(true);
    setGamePlayMode('tournament');
  }

  function handleTournamentPlayBack() {
    setShowTournamentPlay(false);
    gameplayStore.setTournamentPlay(false);
    setStarted(false);
    setGamePlayMode('tournament');
    // Leaving the tournament surface — drop arena mode + cached arena state.
    useArenaStore.getState().resetArena();

    setPosition('rnbqkbnr/pppppppp/8/8/8/8/PPPPPPPP/RNBQKBNR w KQkq - 0 1');
    navigation.setParams({
      tournamentId: undefined,
      tournamentName: undefined,
    });
    // Reset to 0 so the prev-tournamentId effect fires stop_watching for the
    // tournament the user is leaving — otherwise the socket would stay in
    // that tournament's broadcast room even after the tournament chrome is
    // hidden, until the next tournament switch or full unmount.
    setTournamentId(0);
    setGameId('stop_watching');
    if (watchGame) {
      setActiveTab('games');
    } else {
      setActiveTab('details');
    }
  }
  // useEffect(() => {
  //     setIsConnected(client.connected);
  // }, [client, client.connected]);

  function clockToSeconds(clockStr) {
    // Example: "00:00:57" or "01:02:05"
    const parts = clockStr?.split(':').map(Number);

    if (parts?.length === 3) {
      const [hours, minutes, seconds] = parts;
      return hours * 3600 + minutes * 60 + seconds;
    } else if (parts?.length === 2) {
      const [minutes, seconds] = parts;
      return minutes * 60 + seconds;
    } else if (parts?.length === 1) {
      return Number(parts[0]) || 0;
    } else {
      return 0; // fallback for invalid format
    }
  }

  useEffect(() => {
    if (data?.data?.move_with_clock && moveSelected?.selectedMoveNumber) {
      const timer =
        data?.data?.move_with_clock?.[moveSelected.selectedMoveNumber];
      const color = whiteTournament === usernameTournament ? 'white' : 'black';
      setOpponentTimeTournament(timer?.[color === 'white' ? 'black' : 'white']);
      setMyTimeTournament(timer?.[color]);
    }
    if (watchState == 8) {
      console.log("selectedMove:",moveSelected, tournamentMoves[moveSelected.selectedMoveNumber])
      if (tournamentMoves[moveSelected.selectedMoveNumber - 1]?.color == 'w') {
        setWatchWhiteTime(
          clockToSeconds(
            tournamentMoves[moveSelected.selectedMoveNumber - 1]?.clock,
          ),
        );
        setWatchBlackTime(
          clockToSeconds(
            tournamentMoves[moveSelected.selectedMoveNumber -2]?.clock,
          ),
        );
      } else {
        setWatchBlackTime(
          clockToSeconds(
            tournamentMoves[moveSelected.selectedMoveNumber -1]?.clock,
          ),
        );
        setWatchWhiteTime(
          clockToSeconds(
            tournamentMoves[moveSelected.selectedMoveNumber - 2]?.clock,
          ),
        );

      }
    }
  }, [moveSelected, tournamentMoves]);

  // ── Arena berserk window ───────────────────────────────────────────────
  // Allowed only before MY first move of a live arena game (server refuses
  // outside the window anyway: white once moveCount>=1, black once >=2).
  // moves[] holds plies: after n plies white has made ceil(n/2) moves and
  // black floor(n/2).
  const arenaMyMoveCount =
    whitePlayer == username
      ? Math.ceil(moves.length / 2)
      : Math.floor(moves.length / 2);
  const showArenaBerserk = Boolean(
    isArena &&
      arenaStatus?.berserkEnabled &&
      playing &&
      !watchGame &&
      arenaMyMoveCount === 0 &&
      !arenaMyBerserk,
  );

  return (
    <Box style={{backgroundColor: '#FAF6EB', height: '100%'}}>
      <Box
        style={isMobileOrTab ? styles.containerMobile : styles.container}
        flexDirection={isMobileOrTab ? 'column' : 'row'}
        {...(isMobileOrTab && {overflow: 'scroll'})}
        flex={1}>
        {/* Below is the left pane for the chessboard */}
        {!isMobileOrTab && assistedGameplay && started && (
          <Box
            style={{
              width: 25,
              // marginLeft: '8%',
              justifyContent: 'center',
              height: chessboardHeight,
              marginTop: 28,
            }}>
            <WinningBar
              whiteWinRatio={whiteWinRatio}
              blackWinRatio={blackWinRatio}
              reverse={whitePlayer != username}
            />
          </Box>
        )}

        {(!isMobileOrTab ||
          started ||
          playing ||
          (isMobileOrTab &&
            !(showTournamentPlay || searching || challengeInProgress))) && (
          <Box
            style={{
              flex: isMobileOrTab
                ? !(playing || started || showTournamentPlay)
                  ? 0.5
                  : 1
                : showTournamentPlay
                ? 0.55
                : !(playing || started)
                ? 0.5
                : 0.6,
            }}
            onLayout={onParentLayout}>
            <Box
              style={[
                styles.chessboardContainer,
                {
                  width: !(playing || started || showTournamentPlay)
                    ? '100%'
                    : chessboardSize,
                  height: chessboardSize,
                },
                // {flex: isMobileOrTab ? 1 : playing || started ? 0.48 : 0.5},
              ]}>
              {!isConnected && showNotification && (
                <NotificationBox styles={styles} />
              )}

              {started && !isMobileOrTab && !showTournamentPlay && (
                <Box
                  flexDirection="row"
                  style={{
                    marginBottom: 8,
                    marginLeft: gamePlayMode == 'Play' ? '8%' : 0,
                    alignItems: 'flex-start',
                    justifyContent: 'space-between',
                  }}>
                  <CCText>{gameDetails}</CCText>
                  {assistedGameplay && (
                    <Box flexDirection="row" alignItems="center">
                      <CCText style={{marginRight: 18}}>
                        Assisted Gameplay
                      </CCText>
                      {/* <Switch
                        trackColor={{ false: '#767577', true: CCColors.Green }}
                        thumbColor='#f4f3f4'
                        ios_backgroundColor="#3e3e3e"
                        onValueChange={() => setAssistedGameplay(!assistedGameplay)}
                        value={assistedGameplay}
                    /> */}
                    </Box>
                  )}
                </Box>
              )}
              {((isMobileOrTab && (started || playing)) ||
                (!isMobileOrTab && showTournamentPlay)) && (
                <Box
                  style={{
                    height: showTournamentPlay ? chessboardHeight / 10 : 'auto',
                  }}
                  onLayout={onPlayerComponentLayout}>
                  {(playing || started) && !watchGame && (
                    <PlayerComponent
                      flex={2}
                      color={whitePlayer == username ? 'black' : 'white'}
                      username={opponentDisplayName}
                      timer={opponentTime}
                      whitePieces={playerCapturedPieces.w}
                      blackPieces={playerCapturedPieces.b}
                      firstMoveTimer={firstMoveTimer}
                      showFirstMoveTimer={
                        whitePlayer == username
                          ? moves.length == 1
                          : showAbort && !myTurn
                      }
                      rating={opponentRating}
                      myTurn={!myTurn}
                      playing={playing}
                      showTournamentPlay={showTournamentPlay}
                      width={chessboardHeight}
                    />
                  )}

                  {!(playing || started || watchGame) && (
                    <PlayerComponent
                      flex={2}
                      color={
                        whiteTournament == usernameTournament
                          ? 'black'
                          : 'white'
                      }
                      username={opponentTournament}
                      allowReporting={false}
                      timer={opponentTimeTournament}
                      whitePieces={playerCapturedPieces.w}
                      blackPieces={playerCapturedPieces.b}
                      firstMoveTimer={firstMoveTimer}
                      showFirstMoveTimer={false}
                      rating={opponentRatingTournament}
                      myTurn={!myTurn}
                      playing={playing}
                      showTournamentPlay={showTournamentPlay}
                      width={chessboardHeight}
                    />
                  )}
                  {watchGame && (
                    <PlayerComponent
                      flex={2}
                      color={'black'}
                      username={watchBlackUsername}
                      allowReporting={false}
                      timer={watchBlackTime}
                      whitePieces={watchCapturedPieces.w}
                      blackPieces={watchCapturedPieces.b}
                      firstMoveTimer={firstMoveTimer}
                      showFirstMoveTimer={false}
                      rating={watchBlackRating}
                      myTurn={watchCurrentPlayer == watchBlack}
                      playing={watchState !== 8}
                      showTournamentPlay={showTournamentPlay}
                      width={chessboardHeight}
                    />
                  )}
                </Box>
              )}

              {((isMobileOrTab && (started || playing)) ||
                (!isMobileOrTab &&
                  (started || playing || showTournamentPlay))) && (
                <Box
                  style={
                    !playing &&
                    !started &&
                    // !showReviewGamesComponent &&
                    // !hint &&
                    !showTournamentPlay
                      ? {
                          width: '80%',
                          marginHorizontal: 'auto',
                        }
                      : {
                          width: '95%',
                          marginLeft: gamePlayMode == 'Play' ? '8%' : 0,
                        }
                  }
                  onLayout={onChessboardLayout}>
                  {!watchGame && (
                    <ChessboardWithArrow
                      ref={chessboardRef}
                      disabled={
                        !playing ||
                        (thinkingTime &&
                          customRules.includes('thinking_time_rule') &&
                          gamePlayMode == 'Play')
                      }
                      boardOrientation={
                        whitePlayer == username ? 'white' : 'black'
                      }
                      position={position}
                      onPieceDropExtension={makeMove}
                      lastMoveFen={previousFen}
                      arePremovesAllowed={playing}
                      colorTheme={chessboardColorTheme}
                      animationDuration={10}
                      restrictPiece={restrictPiece}
                      restrictedPiece={restrictedPiece}
                    />
                  )}
                  {watchGame && (
                    <ChessboardWithArrow
                      ref={chessboardRef}
                      disabled={true}
                      boardOrientation={'white'}
                      position={watchGameState}
                      // onPieceDropExtension={makeMove}
                      lastMoveFen={watchPrevGameState}
                      // arePremovesAllowed={playing}
                      colorTheme={chessboardColorTheme}
                      animationDuration={10}
                      // restrictPiece={restrictPiece}
                      // restrictedPiece={restrictedPiece}
                    />
                  )}
                </Box>
              )}
              {!(playing || started || showTournamentPlay) && (
                <IdleStateGameBanner
                  // green
                  // #937ADB
                  // #7F62D1

                  // purple
                  // #3DAB9E
                  // #1E8175
                  StartColor={
                    gamePlayMode == 'Play'
                      ? '#3DAB9E'
                      : gamePlayMode == 'Play and Learn'
                      ? '#937ADB'
                      : '#FBA0E3'
                  }
                  StopColor={
                    gamePlayMode == 'Play'
                      ? '#1E8175'
                      : gamePlayMode == 'Play and Learn'
                      ? '#7F62D1'
                      : '#FBA0E3'
                  }
                  visible={
                    true
                    // !playing ||
                    // (thinkingTime && customRules.includes('thinking_time_rule'))
                  }
                  gamePlayMode={gamePlayMode}
                  isMobileOrTab={isMobileOrTab}
                />
              )}
              {((isMobileOrTab && (started || playing)) ||
                (!isMobileOrTab && showTournamentPlay)) && (
                <Box
                  style={{
                    height: showTournamentPlay ? chessboardHeight / 9 : 'auto',
                  }}>
                  {(playing || started) && !watchGame && (
                    <PlayerComponent
                      flex={2}
                      color={whitePlayer == username ? 'white' : 'black'}
                      username={displayName}
                      allowReporting={false}
                      timer={myTime}
                      whitePieces={playerCapturedPieces.w}
                      blackPieces={playerCapturedPieces.b}
                      firstMoveTimer={firstMoveTimer}
                      showFirstMoveTimer={showAbort && myTurn}
                      rating={myRating}
                      myTurn={myTurn}
                      playing={playing}
                      showTournamentPlay={showTournamentPlay}
                      width={chessboardHeight}
                    />
                  )}

                  {!(playing || started || watchGame) && (
                    <PlayerComponent
                      flex={2}
                      color={
                        whiteTournament == usernameTournament
                          ? 'white'
                          : 'black'
                      }
                      username={displayNameTournament}
                      allowReporting={false}
                      timer={myTimeTournament}
                      whitePieces={playerCapturedPieces.w}
                      blackPieces={playerCapturedPieces.b}
                      firstMoveTimer={firstMoveTimer}
                      showFirstMoveTimer={false}
                      rating={myRatingTournament}
                      myTurn={!myTurn}
                      playing={playing}
                      showTournamentPlay={showTournamentPlay}
                      width={chessboardHeight}
                    />
                  )}
                  {watchGame && (
                    <PlayerComponent
                      flex={2}
                      color={'white'}
                      username={watchWhiteUsername}
                      allowReporting={false}
                      timer={watchWhiteTime}
                      whitePieces={watchCapturedPieces.w}
                      blackPieces={watchCapturedPieces.b}
                      firstMoveTimer={firstMoveTimer}
                      showFirstMoveTimer={false}
                      rating={watchWhiteRating}
                      myTurn={watchCurrentPlayer == watchWhite}
                      playing={watchState != 8}
                      showTournamentPlay={showTournamentPlay}
                      width={chessboardHeight}
                    />
                  )}
                </Box>
              )}

              {!isMobileOrTab &&
                !(gamePlayMode == 'tournament' || showTournamentPlay) && (
                  <Box
                    flexDirection="row"
                    flexWrap="wrap"
                    style={{width: '100%', justifyContent: 'space-evenly'}}>
                    {!isMobileOrTab &&
                      playing &&
                      myTurn &&
                      thinkingTime &&
                      gamePlayMode == 'Play' &&
                      customRules.includes('thinking_time_rule') && (
                        <Box
                          style={{
                            width: chessboardHeight,
                            alignItems: 'center',
                            display: 'flex',
                            justifyContent: 'center',
                            backgroundColor: CCColors.Red,
                            height: 40,
                            marginLeft: '8%',
                          }}>
                          <CCText style={{color: 'white', marginLeft: 4}}>
                            Thinking time!
                          </CCText>
                        </Box>
                      )}
                    {!isMobileOrTab &&
                      playing &&
                      assistedGameplay &&
                      hintMessage && (
                        <Box
                          style={{
                            width: '100%',
                            alignItems: 'center',
                            display: 'flex',
                            justifyContent: 'center',
                            backgroundColor: CCColors.Red,
                            height: 'auto',
                          }}>
                          <CCText
                            style={{
                              color: 'white',
                              marginLeft: 6,
                              marginTop: 8,
                              marginBottom: 8,
                              marginRight: 6,
                            }}>
                            {hintMessage}
                          </CCText>
                        </Box>
                      )}
                  </Box>
                )}
              {isMobileOrTab &&
                playing &&
                myTurn &&
                thinkingTime &&
                customRules.includes('thinking_time_rule') && (
                  <Box>
                    <CCText style={{color: 'green', marginLeft: 4}}>
                      Thinking time!
                    </CCText>
                  </Box>
                )}
              {isMobileOrTab &&
                (playing || started) &&
                customRules.length > 0 && <GameRules rules={customRules} />}
            </Box>
          </Box>
        )}

        {/* Below is the right pane */}
        {/* When not playing */}
        {isStaff && !playing && !challengeInProgress && searching && (
          <SearchProgressComponent
            visible={searching}
            cancelSearch={cancelJoinGameRequest}
            started={foundOpponent}
            opponent={opponentDisplayName}
          />
        )}
        {isStaff &&
          !playing &&
          !challengeInProgress &&
          !searching &&
          !started &&
          !showTournamentPlay && (
            <GameSearchComponent
              joinGame={joinGame}
              challengeGame={challengeGame}
              user={username}
              searchPlayers={searchPlayers}
              searchPlayersResult={searchPlayersResult}
              lastTimecontrol={MoveTimer / 60000 + '+' + Increment / 1000}
              showReviewGamesComponent={showReviewGamesComponent}
              customRules={customRules}
              setAssistedGameplay={setAssistedGameplay}
              setGameDetails={setGameDetails}
              isStaff={isStaffNew}
              setGamePlayMode={setGamePlayMode}
              enableLearn={enableLearn}
              gamePlayMode={gamePlayMode}
              getTournamentDetails={getTournamentDetails}
              isBeginnerPlayer={isBeginnerPlayer}
              withdraw={withdraw}
            />
          )}
        {isStaff && !playing && !searching && challengeInProgress && (
          <ChallengeProgressComponent
            visible={challengeInProgress}
            cancelSearch={handleChallengeCancel}
            opponent={ChallengeOpponent.split(':')[1]}
            opponentId={ChallengeOpponent.split(':')[0]}
            gameDetails={`                   ${gameDetails}`}
            isBeginnerPlayer={isBeginnerPlayer}
            //   featureText={}
          />
        )}

        {isStaff &&
          !isMobileOrTab &&
          (playing || started) &&
          !showTournamentPlay && (
            <Box
              flexDirection="column"
              flex={0.48}
              style={{
                height: '100%',
                overflow: 'visible',
                alignItems: 'center',
                marginLeft: '5%',
              }}>
              {/* <Box
              flexDirection="row"
              style={{alignItems: 'flex-end', marginBottom: 8}}>
              <CCText color="#FAF6EB" style={{marginRight: 18}}>
                Assisted Gameplay
              </CCText>
            </Box> */}
              <Box
                flexDirection="row"
                style={{
                  marginBottom: 8,
                  alignItems: 'flex-start',
                  justifyContent: 'space-between',
                }}>
                <CCText> </CCText>
              </Box>
              <Box style={{height: chessboardHeight, width: chessboardHeight}}>
                <NotationComponent
                  moves={isBlackTurnFirst ? [{}, ...moves] : moves}
                  opponentTime={opponentTime}
                  myTime={myTime}
                  myTurn={myTurn}
                  username={username}
                  white={whitePlayer}
                  displayName={displayName}
                  opponent={opponentDisplayName}
                  whitePieces={playerCapturedPieces.w}
                  blackPieces={playerCapturedPieces.b}
                  setPosition={setPosition}
                  firstMoveTimer={firstMoveTimer}
                  showFirstMoveTimer={showAbort && myTurn && playing}
                  setMoveClicked={setMoveClicked}
                  setMoveSelected={setMoveSelected}
                  startfen={startfen}
                  setPreviousFen={setPreviousFen}
                  myRating={myRating}
                  opponentRating={opponentRating}
                  playing={playing}
                  setHint={setHint}
                  setHint2={setHint2}
                  isBlackTurnFirst={isBlackTurnFirst}
                  position={'relative'}
                  setShowIncorrectHintModal={setShowIncorrectHintModal}
                  illegalTouchPieceCount={illegalTouchPieceCount}
                  isBeginnerPlayer={isBeginnerPlayer}
                  opponentId={whitePlayer == username ? blackPlayer : whitePlayer}
                  isArena={isArena}
                />
              </Box>

              {hint && showIncorrectHintModal && (
                <Box
                  style={{
                    width: '100%',
                    justifyContent: 'center',
                    alignItems: 'center',
                    position: 'absolute',
                    top: 63,
                    right: 20,
                    zIndex: 1000,
                  }}>
                  <HintForIncorrectAttempt
                    infoiconcolor={CCColors.BlueAqua}
                    borderColor={CCColors.BlueAqua}
                    padding={10}
                    title={'Engine Suggestion'}
                    width={'90%'}
                    result={hint}
                    result2={hint2}
                    disabled={!isStaff}
                    setShowIncorrectHintModal={setShowIncorrectHintModal}
                    handleSubmit={handleSubmit}
                    showChange={showChange}
                    setShowChange={setShowChange}
                    goodFeedback={goodFeedback}
                    badFeedback={badFeedback}
                    setGoodFeedback={setGoodFeedback}
                    setBadFeedback={setBadFeedback}
                  />
                </Box>
              )}
              <Box type="row-center-between" style={{width: '80%', height: 80}}>
                <Box>
                  {playing && (
                    <BottomControlsComponent
                      showDrawRequest={showDrawRequest}
                      drawRequestSent={drawRequestSent}
                      drawRequest={drawRequest}
                      handleDrawResponse={handleDrawResponse}
                      resign={resign}
                      abort={abort}
                      showAbort={showAbort}
                      playing={playing}
                      showDrawReject={showDrawReject}
                      setShowDrawReject={setShowDrawReject}
                    />
                  )}
                  <Box
                    style={{
                      width: '100%',
                      justifyContent: 'center',
                      marginTop: 12,
                      // alignItems: 'center',
                    }}>
                    {!(
                      !game_uuid ||
                      playing ||
                      Result == 'Abort' ||
                      gamePlayMode == 'tournament' ||
                      gamePlayMode == 'arena' // arena auto-pairs; no manual rematch
                    ) && (
                      <View style={[styles.cardHeading]}>
                        <CCButton
                          onPress={() => {
                            navigation.navigate(ScreenName.ChessAnalysis, {
                              game_id: game_uuid,
                            });
                          }}
                          disabled={!game_uuid || playing}
                          style={styles.reviewGameAction}
                          contentContainerStyle={{
                            paddingRight: 8,
                            paddingVertical: 8,
                            paddingLeft: 24,
                          }}>
                          <View
                            style={{
                              flex: 1,
                              justifyContent: 'space-between',
                              flexDirection: 'row',
                              alignItems: 'center',
                            }}>
                            <CCText style={styles.reviewGameActionText}>
                              Review
                            </CCText>
                            <View
                              style={[
                                styles.reviewGameActionCoinsContainer,
                                {marginLeft: 8},
                              ]}>
                              <FontAwesome5
                                name="coins"
                                size={16}
                                color="#D1AB41"
                              />
                              <CCText style={{marginLeft: 8}}>50+ pts</CCText>
                            </View>
                          </View>
                        </CCButton>
                      </View>
                    )}
                    {/* {gamePlayMode == 'Tournament' &&
                    <View style={[styles.cardHeading]}>
                      <CCButton onPress={() => {setShowTournamentPlay(true)}} style={styles.ctaButton}>
                        <CCText style={styles.ctaText}> show tournament </CCText>
                      </CCButton>
                    </View>
                  } */}
                  </Box>
                </Box>
                <Box
                  style={{
                    flexDirection: 'row',
                    justifyContent: 'space-evenly',
                    marginTop: 12,
                    marginRight: 10,
                  }}>
                  {!(playing || !ChallengeOpponent || !ChallengeMoveTimer) &&
                    started &&
                    !hint && (
                      <CustomInfoBox
                        text="Rematch"
                        customView={
                          <Box
                            style={styles.iconButton}
                            onPress={() =>
                              challengeGame(
                                ChallengeOpponent,
                                ChallengeMoveTimer,
                                ChallengeIncrement,
                                ChallengeWhite,
                              )
                            }>
                            <img
                              src={rematch}
                              style={{width: 24, height: 24}}
                              alt="Rematch"
                            />
                          </Box>
                        }
                      />
                    )}

                  {!(!MoveTimer || playing) &&
                    !showReviewGamesComponent &&
                    started &&
                    !hint && (
                      <CustomInfoBox
                        text={`New ${MoveTimer / 60000} + ${Increment / 1000}`}
                        customView={
                          <Box
                            style={styles.iconButton}
                            onPress={() => joinGame(MoveTimer, Increment)}>
                            <img
                              src={newGame}
                              style={{width: 24, height: 24}}
                              alt="New Game"
                            />
                          </Box>
                        }
                      />
                    )}

                  {!playing &&
                    started &&
                    !showReviewGamesComponent &&
                    !hint && (
                      <CustomInfoBox
                        text="New Game"
                        customView={
                          <Box
                            style={styles.iconButton}
                            onPress={handle_new_game}>
                            <img
                              src={home}
                              style={{width: 40, height: 40}}
                              alt="New Game"
                            />
                          </Box>
                        }
                      />
                    )}
                </Box>
                {playing && <GameRules rules={customRules} />}
              </Box>
            </Box>
          )}
        {isStaff && isMobileOrTab && (playing || started) && (
          <>
            <BottomSheetPlay
              minHeight={
                WINDOW_HEIGHT -
                chessboardHeight -
                MOBILE_HEADER_HEIGHT -
                2 * playerComponentHeight
              }>
              {started && (
                <Box
                  flexDirection="row"
                  gap={20}
                  style={{
                    alignItems: 'flex-start',
                    justifyContent: 'center',
                  }}>
                  <CCText>{gameDetails}</CCText>
                  {assistedGameplay && (
                    <Box flexDirection="row" alignItems="center">
                      <CCText style={{marginRight: 18}}>
                        Assisted Gameplay
                      </CCText>
                    </Box>
                  )}
                </Box>
              )}
              <Box
                flexDirection="column"
                flex={1}
                style={{
                  height: '100%',
                  overflow: 'visible',
                  alignItems: 'center',
                  // marginLeft: '5%',
                }}>
                <NotationComponent
                  moves={isBlackTurnFirst ? [{}, ...moves] : moves}
                  opponentTime={opponentTime}
                  myTime={myTime}
                  myTurn={myTurn}
                  username={username}
                  white={whitePlayer}
                  displayName={displayName}
                  opponent={opponentDisplayName}
                  whitePieces={playerCapturedPieces.w}
                  blackPieces={playerCapturedPieces.b}
                  setPosition={setPosition}
                  firstMoveTimer={firstMoveTimer}
                  showFirstMoveTimer={showAbort && myTurn && playing}
                  setMoveClicked={setMoveClicked}
                  setMoveSelected={setMoveSelected}
                  startfen={startfen}
                  setPreviousFen={setPreviousFen}
                  myRating={myRating}
                  opponentRating={opponentRating}
                  playing={playing}
                  setHint={setHint}
                  setHint2={setHint2}
                  isBlackTurnFirst={isBlackTurnFirst}
                  position={'relative'}
                  showPlayerComponent={false}
                  illegalTouchPieceCount={illegalTouchPieceCount}
                  isArena={isArena}
                />

                {hint && showIncorrectHintModal && (
                  <Box
                    style={{
                      width: '90%',
                      justifyContent: 'center',
                      alignItems: 'center',
                      position: 'absolute',
                      top: 63,
                      right: 20,
                      zIndex: 1000,
                    }}>
                    <HintForIncorrectAttempt
                      infoiconcolor={CCColors.BlueAqua}
                      borderColor={CCColors.BlueAqua}
                      padding={10}
                      title={'Engine Suggestion'}
                      width={'90%'}
                      result={hint}
                      result2={hint2}
                      disabled={!isStaff}
                      setShowIncorrectHintModal={setShowIncorrectHintModal}
                      handleSubmit={handleSubmit}
                      showChange={showChange}
                      setShowChange={setShowChange}
                      goodFeedback={goodFeedback}
                      badFeedback={badFeedback}
                      setGoodFeedback={setGoodFeedback}
                      setBadFeedback={setBadFeedback}
                    />
                  </Box>
                )}
                <Box type="row-center" style={{width: '90%', height: '10vh'}}>
                  <Box>
                    {isArena && playing && (
                      <ArenaBerserkControl
                        canBerserk={showArenaBerserk}
                        onBerserk={() => sendArenaBerserk(tableId)}
                      />
                    )}
                    {playing && (
                      <BottomControlsComponent
                        showDrawRequest={showDrawRequest}
                        drawRequestSent={drawRequestSent}
                        drawRequest={drawRequest}
                        handleDrawResponse={handleDrawResponse}
                        resign={resign}
                        abort={abort}
                        showAbort={showAbort}
                        playing={playing}
                        showDrawReject={showDrawReject}
                        setShowDrawReject={setShowDrawReject}
                      />
                    )}
                    <Box
                      style={{
                        width: '100%',
                        justifyContent: 'center',
                        marginTop: 5,
                        alignItems: 'center',
                      }}>
                      {!(!game_uuid || playing || Result == 'Abort') && (
                        <View style={[styles.cardHeading]}>
                          <CCButton
                            onPress={() => {
                              navigation.navigate(ScreenName.ChessAnalysis, {
                                game_id: game_uuid,
                              });
                            }}
                            disabled={!game_uuid || playing}
                            style={styles.reviewGameAction}
                            contentContainerStyle={{
                              paddingRight: 8,
                              paddingVertical: 4,
                              paddingLeft: 24,
                            }}>
                            <View
                              style={{
                                flex: 1,
                                justifyContent: 'center',
                                flexDirection: 'row',
                                alignItems: 'center',
                              }}>
                              <CCText style={styles.reviewGameActionText}>
                                Review Game
                              </CCText>
                              <View
                                style={[
                                  styles.reviewGameActionCoinsContainer,
                                  {marginLeft: 8},
                                ]}>
                                <FontAwesome5
                                  name="coins"
                                  size={16}
                                  color="#D1AB41"
                                />
                                <CCText style={{marginLeft: 8}}>50+ pts</CCText>
                              </View>
                            </View>
                          </CCButton>
                        </View>
                      )}
                    </Box>
                  </Box>
                  <Box justifyContent="flex-end">
                    <GameRules rules={customRules} />
                  </Box>
                </Box>
                <Box
                  flexDirection="row"
                  flexWrap="wrap"
                  style={{
                    width: '75%',
                    justifyContent: 'space-evenly',
                    marginBottom: 5,
                  }}>
                  {!(playing || !ChallengeOpponent || !ChallengeMoveTimer) &&
                    started &&
                    !hint && (
                      <CCButton
                        onPress={() =>
                          challengeGame(
                            ChallengeOpponent,
                            ChallengeMoveTimer,
                            ChallengeIncrement,
                            ChallengeWhite,
                          )
                        }
                        disabled={
                          playing || !ChallengeOpponent || !ChallengeMoveTimer
                        }
                        flex={0.8}
                        style={{
                          backgroundColor: 'white',
                          borderColor: 'black',
                          borderWidth: 1,
                          width: 'auto',
                          marginTop: 2,
                        }}>
                        <img src={rematch} />
                        <CCText style={{color: 'black', marginLeft: 4}}>
                          Rematch
                        </CCText>
                      </CCButton>
                    )}
                  {!(!MoveTimer || playing) &&
                    !showReviewGamesComponent &&
                    started &&
                    !hint && (
                      <CCButton
                        onPress={() => joinGame(MoveTimer, Increment)}
                        disabled={!MoveTimer || playing}
                        flex={0.8}
                        style={{
                          backgroundColor: 'white',
                          borderColor: 'black',
                          borderWidth: 1,
                          width: 'auto',
                          marginTop: 2,
                        }}>
                        <img src={rematch} />
                        <CCText style={{color: 'black', marginLeft: 4}}>
                          New {MoveTimer / 60000} + {Increment / 1000}
                        </CCText>
                      </CCButton>
                    )}
                  {!playing &&
                    started &&
                    !showReviewGamesComponent &&
                    started &&
                    !hint && (
                      <CCButton
                        onPress={() => handle_new_game()}
                        flex={0.8}
                        style={{
                          backgroundColor: 'white',
                          borderColor: 'black',
                          borderWidth: 1,
                          width: 'auto',
                          marginTop: 2,
                          zIndex: isMobileOrTab && 100,
                        }}>
                        <img src={rematch} />
                        <CCText style={{color: 'black', marginLeft: 4}}>
                          New Game
                        </CCText>
                      </CCButton>
                    )}
                </Box>
              </Box>
            </BottomSheetPlay>
          </>
        )}
        <Modal
          visible={searching && false}
          animationType="slide"
          transparent={true}>
          <View
            style={{
              flex: 1,
              justifyContent: 'center',
              alignItems: 'center',
              backgroundColor: 'rgba(0, 0, 0, 0.5)',
            }}>
            <View
              style={{backgroundColor: 'white', padding: 20, borderRadius: 10}}>
              <Text>Searching opponent .. </Text>
              <CCButton
                onPress={e => {
                  cancelJoinGameRequest();
                }}
                style={{margin: 4}}>
                Cancel Search
              </CCButton>
            </View>
          </View>
        </Modal>
        <Modal
          visible={gameState === 1}
          animationType="fade"
          transparent={true}>
          <View
            style={{
              flex: 1,
              justifyContent: 'center',
              alignItems: 'center',
              backgroundColor: 'rgba(0, 0, 0, 0.5)',
            }}>
            <View
              style={{backgroundColor: 'white', padding: 20, borderRadius: 10}}>
              <Text>Game to start in</Text>
              <View
                style={{
                  flexDirection: 'row',
                  justifyContent: 'space-around',
                  marginTop: 20,
                }}>
                <Text style={{fontSize: 24}}>{gameStartTime / 1000} s</Text>
              </View>
            </View>
          </View>
        </Modal>
        {/* <ChallengeComponent
          challenger={ChallengeOpponent}
          visible={showChallengeRequest}
          handleChallengeResponse={handleChallengeResponse}
          timeControl={
            (ChallengeMoveTimer / 60000).toString() +
            ' + ' +
            (ChallengeIncrement / 1000).toString()
          }
        /> */}
        <ResultComponent
          visible={
            showEndGameModal && gameplayStore?.showEndGameModal && !watchGame
          }
          result={Result}
          endGameMessage={endGameMessage}
          endType={endType}
          game_uuid={game_uuid}
          handle_end_game_modal={handle_end_game_modal}
          joinGame={joinGame}
          challengeGame={challengeGame}
          challenger={ChallengeOpponent}
          moveTimer={MoveTimer}
          Increment={Increment}
          challengeMoveTimer={ChallengeMoveTimer}
          challengeIncrement={ChallengeIncrement}
          white={ChallengeWhite}
          opponent={whitePlayer == username ? blackPlayer : whitePlayer}
          myRating={myRating}
          myRatingChange={myRatingChange}
          lastfen={startfen}
          gamePlayMode={gamePlayMode}
          pgn={pgn}
        />
        <Modal visible={showEngineEvaluatingModal} animationType="fade" transparent={true}>
          <View
            style={{
              flex: 1,
              justifyContent: 'center',
              alignItems: 'center',
              backgroundColor: 'rgba(0, 0, 0, 0.5)',
            }}>
            <View style={{backgroundColor: 'white', padding: 20, borderRadius: 10}}>
              <Text style={{fontSize: 18, fontWeight: '600', color: '#222'}}>
              As per Opening Mastery Series rules, games conclude after 20 moves. This game has ended, and the result is being evaluated
              </Text>
              <Text style={{fontSize: 14, marginTop: 8, color: '#555'}}>
                Stockfish is calculating the final result. Please wait...
              </Text>
              <View style={{marginTop: 16, alignItems: 'center'}}>
                <ActivityIndicator size="large" color="#4B7BEC" />
              </View>
            </View>
          </View>
        </Modal>
        <ChallengeRejected
          Visible={showChallengeReject && gameplayStore?.showChallengeReject && gameplayStore.allowChallenge}
          message="Challenge Rejected!"
          handle_close={handle_challenge_reject}
        />
        <ChallengeRejected
          Visible={showChallengeExpire && gameplayStore?.showChallengeExpire && gameplayStore.allowChallenge}
          message="The challenge has expired!"
          handle_close={handle_challenge_reject}
        />
        <ChallengeRejected
          Visible={showChallengeCancel && gameplayStore?.showChallengeCancel && gameplayStore.allowChallenge}
          message="Challenge Cancelled!"
          handle_close={handle_challenge_reject}
        />
        <ChallengeRejected
          Visible={showPlayerNotFound}
          message={`${
            MoveTimer == 60000
              ? "Bullet games aren't very popular on Circlechess right now. Try other formats for a better chance to find opponents!"
              : 'Players not available, Try again later!'
          }`}
          handle_close={handle_challenge_reject}
        />

        <ChallengeRejected
          Visible={showTnrStarting}
          message={
            tnrStartingMessage ||
            "You have a tournament starting soon, can't play this time control game!"
          }
          handle_close={handle_challenge_reject}
        />

        {showTournamentPlay && !(isMobileOrTab && (playing || started)) && (
          <Box flex={isMobileOrTab ? 1 : 0.5}>
            <TournamentPlay
              tournamentId={tournamentId}
              handleBack={handleTournamentPlayBack}
              joinTournament={joinTournament}
              userId={username}
              playersJoined={tournamentPlayersJoined}
              active_tab={activeTab}
              moves={isBlackTurnFirst ? [{}, ...moves] : moves}
              opponentTime={opponentTime}
              myTime={myTime}
              myTurn={myTurn}
              username={username}
              white={whitePlayer}
              displayName={displayName}
              opponent={opponentDisplayName}
              whitePieces={playerCapturedPieces.w}
              blackPieces={playerCapturedPieces.b}
              setPosition={setPosition}
              firstMoveTimer={firstMoveTimer}
              showFirstMoveTimer={showAbort && myTurn && playing}
              setMoveClicked={setMoveClicked}
              setMoveSelected={setMoveSelected}
              startfen={startfen}
              setPreviousFen={setPreviousFen}
              myRating={myRating}
              opponentRating={opponentRating}
              playing={playing}
              setHint={setHint}
              setHint2={setHint2}
              isBlackTurnFirst={isBlackTurnFirst}
              position={'relative'}
              current_round={round}
              setShowIncorrectHintModal={setShowIncorrectHintModal}
              roundStartTime={roundStartTime}
              setWhitePlayer={setWhitePlayer}
              game_uuid={game_uuid}
              roundEnd={roundEnd}
              showDrawRequest={showDrawRequest}
              drawRequestSent={drawRequestSent}
              drawRequest={drawRequest}
              handleDrawResponse={handleDrawResponse}
              resign={resign}
              abort={abort}
              showAbort={false}
              showDrawReject={showDrawReject}
              setShowDrawReject={setShowDrawReject}
              setGameId={setGameId}
              tournamentMoves={tournamentMoves}
              startfenTournament={startfenTournament}
              withDrawPlayer={withDrawPlayer}
              illegalTouchPieceCount={illegalTouchPieceCount}
              setMyTimeTournament={setMyTimeTournament}
              setOpponentTimeTournament={setOpponentTimeTournament}
              started={started}
              watchTournamentGame={watchTournamentGame}
              watchGame={watchGame}
              setStarted={setStarted}
              tournamentEnded={tournamentEnded}
              gamesEnded={gamesEnded}
              isConnected={isConnected}
              joinMessage={joinMessage}
              joinTnrSuccess={joinTnrSuccess}
              setJoinTnrSuccess={setJoinTnrSuccess}
              displayNameTournament={displayNameTournament}
              setWithdraw={setWithdraw}
              ongoingGames={ongoingGames}
              isPairingGenerated={isPairingGenerated}
              getTournamentStatus={getTournamentStatus}
              tournamentState={tournamentState}
              tournamentStatusMessage={tournamentStatusMessage}
              onArenaPause={sendArenaPause}
              onArenaResume={sendArenaResume}
              onArenaBerserk={() => sendArenaBerserk(tableId)}
              showArenaBerserk={showArenaBerserk}
              openArenaGame={openArenaGameByTable}
            />
          </Box>
        )}
        {/* <Modal
          animationType="slide"
          transparent={true}
          visible={gameplayStore?.showChangeInClient}
          onRequestClose={handleClose}
        >
          <View style={connectionStyles.overlay}>
            <View style={connectionStyles.modalView}>
              <Text style={connectionStyles.modalText}>
                Connection detected on another tab.
              </Text>
              <Text style={connectionStyles.modalText}>
                Do you want to continue playing on this tab or navigate to Dashboard and use other features?
              </Text>
              <View style={connectionStyles.buttonContainer}>
                <Button title= "Continue" onPress={handleContinue} />
                <Button title="Navigate to Dashboard" onPress={handleClose} color="red" />
              </View>
            </View>
          </View>
        </Modal> */}

        {!isStaff && <ComingSoon feature={'Game Play'} cover_img={2} />}
      </Box>
      <ConnectionModal
        visible={changeClient || !authComplete}
        onContinue={handleContinue}
        onClose={handleClose}
        authFail={!authComplete}
      />
      {gamePlayMode == 'Play and Learn' && (
        <StockfishEngine
          fen={fen}
          depth={32}
          variations={1}
          engineOn={assistedGameplay}
          onResult={handleStockfishResult}
        />
      )}
    </Box>
  );
}

export default PlayChess;
